<template>
  <div class="d-flex flex-column">


        <!-- Loading Overlay -->
    <div v-if="isRefreshing" class="position-fixed top-0 start-0 end-0 bottom-0 d-flex align-items-center justify-content-center" 
     style="background: rgba(0, 0, 0, 0.5); z-index: 9999; backdrop-filter: blur(2px);">
      <div class="bg-white rounded-3 p-4 text-center shadow-lg" style="min-width: 300px; max-width: 400px;">
        <div class="spinner-border text-primary mb-3" style="width: 3rem; height: 3rem;" role="status">
          <span class="visually-hidden">Loading...</span>
        </div>
        <h5 class="text-primary fw-semibold mb-2">Loading Weather Data</h5>
        <p class="text-muted small mb-3">Please wait while we fetch your data...</p>
        <button type="button" class="btn btn-sm btn-outline-secondary" @click="cancelDataRefresh">
          <i class="bi bi-x-circle me-1"></i> Cancel
        </button>
      </div>
    </div>

    <div class="mb-3  d-flex align-items-end justify-content-between">

    </div>
    
    <div v-if="showSignup" class="col-md-8">
      <SignUp completionPath="" showCancel="true" @cancel="showSignup = false" @signupcomplete="showSignup = false">
      </SignUp>
    </div>
    <template v-else>

      <div v-if="!hasSession && isContainerInited" class="alert alert-primary my-3" role="alert">
        <i class="bi bi-lock"></i>You aren't signed into an account. Some features will be restricted. <a
          class="alert-link" href="#" onclick="window.dialogManager?.showSignIn(); return false;"> Sign in</a> or <a
          class="alert-link" href="#" @click="showSignup = true">Sign up</a>.
      </div>







      <div class="d-flex justify-content-between align-items-center mb-2">

        <h1 class="mb-0 h4">
          <button v-if="hasSavedDefn" type="button" class="btn btn-outline-primary btn-sm mx-1"
            @click="savePackage(packageDefn)">
            <i class="bi bi-save"></i><span class="d-none d-lg-inline"> Save</span>
          </button>

          <button type="button" class="btn btn-outline-primary btn-sm mx-1" @click="saveAs(packageDefn)">
            <i class="bi bi-file-earmark-plus"></i><span class="d-none d-lg-inline"> Save As</span>
          </button>

          {{ taskName }}
          
        </h1>
        <button v-if="hasSchedule" type="button" class="btn btn-outline-primary btn-sm mx-1"
          @click="openDownloadDialog('schedule')">
          <i class="bi bi-clock"></i> 
        </button>
        <button v-if="hasWeatherStats" type="button" class="btn btn-outline-primary btn-sm mx-1"
          @click="openDownloadDialog('stats')">
          <i class="bi bi-graph-up"></i> 
        </button>
        <div class="ms-auto d-flex gap-2" role="group" aria-label="View options">
         
          <button class="btn btn-sm text-primary" @click="showFeedback()">
              <i class="bi bi-chat-dots me-1"></i> Provide feedback
          </button>
          
          <button type="button" class="btn btn-outline-primary btn-sm" :disabled="!hasSession"
            @click="openMyDatasetsDialog()">
            <i class="bi bi-grid-3x3"></i><span class="d-none d-md-inline"> My Datasets</span>
          </button>
        </div>

      </div>



      <div class="position-relative ">




        <div v-if="validLocation" class="row mt-0 mb-0 bg-primary rounded-top">

          <div class="col-12 col-md-6">
            <template v-if="showLocationDropdown">
              <div class="d-flex align-items-center justify-content-start">
                <button class="btn btn-outline-primary text-light  px-1" type="button" @click="showLocationEdit()">
                  <i class="bi bi-pencil"></i>
                </button>

                <!-- Vue-controlled dropdown -->
                <div class="dropdown" ref="locationDropdown">
                  <button class="btn dropdown-toggle btn-outline-primary text-truncate text-light px-1" type="button"
                    @click="showLocationDropdownMenu = !showLocationDropdownMenu"
                    :aria-expanded="showLocationDropdownMenu">
                    <div class="d-inline-block d-lg-none">{{ selectedLocationText }}</div>
                    <div class="d-none d-lg-inline-block">{{ selectedLocationTextLong }}</div>
                  </button>

                  <ul class="dropdown-menu" :class="{ show: showLocationDropdownMenu }" @click="handleDropdownClick">

                    <li class="dropdown-item-text ps-2 fw-bold">Dataset locations:</li>

                    <li v-for="(location, index) in previewLocations" :key="index">
                      <a class="dropdown-item" href="#" @click.prevent="changeSelectedLocation(index)">
                        {{ getLocationText(location, 50) }}
                      </a>
                    </li>

                    <li v-if="hasMoreLocations">
                      <a class="dropdown-item" href="#" @click.prevent.stop="openLocationsDialog()">
                        +{{ locations.length - previewLocations.length }} more
                      </a>
                    </li>

                    <li class="mt-3 ps-2">
                      <a class="" href="#" @click.prevent.stop="openLocationsDialog()">
                        <i class="bi bi-geo"></i> Edit locations
                      </a>
                    </li>

                  </ul>
                </div>
              </div>

            </template>

            <template v-if="showLocationAdd">
              <div class="d-flex flex-column m-2 ">
                <div class="input-group  p-0">
                  <input v-model="newLocation" v-on:keyup.enter="addLocation()" class="form-control" type="text"
                    placeholder="Enter a location">
                  <button @click="addLocation()" type="button"
                    class="input-group-text btn btn-outline-primary bg-white"> <i class="bi bi-search"></i></button>
                </div>
                <a class="text-light fs-sm" href="#" @click.prevent.stop="findMyLocation()">
                  <i class="bi bi-geo-alt "></i> Use your location
                </a>
              </div>
            </template>
            <div id="locationHelpBlock" class="form-text text-light mt-0 mb-1  ">
              <span class="opacity-70">Addresses, partial addresses or lat,lon</span>
              <VcTooltip title="Locations"
                content="Enter one or more locations using addresses, partial addresses or lat,lon." placement="bottom"
                trigger="hover">
                <a href="#" class="ms-1 text-light opacity-80">
                  <i class="bi bi-question-circle"></i>
                </a>
              </VcTooltip>
            </div>
          </div>
          <div class="col-6 col-md-3">

            <DateRangeChooser linkClass="text-light py-2" :queryDefinition="queryDefn" :queryData="resultData"
              @change:daterange="setDateRange">
            </DateRangeChooser>
            <div id="dateHelpBlock" class="form-text text-light mt-0 mb-1">
              <span class="opacity-70">History or forecast data</span>
              <VcTooltip title="Dates"
                content="Retrieve weather forecast or historical weather data by choosing a date range."
                placement="bottom" trigger="hover">
                <a href="#" class="ms-1 text-light opacity-80">
                  <i class="bi bi-question-circle"></i>
                </a>
              </VcTooltip>
            </div>

          </div>

          <div v-if="validLocation" class="col-6 col-md-3">
            <div class="d-flex align-items-center  justify-content-between">
              <UnitGroupDropdown v-model="queryDefn.unitGroup" linkClass="text-light" />
              <button class="btn text-light mt-0 mb-1" type="button" @click="openDataSectionsEditor()"><i
                  class="bi  bi-grid-1x2"></i> Options</button>

            </div>
            <div id="locationHelpBlock" class="form-text text-light mt-0 mb-1">
              <span class="opacity-70">Data units</span>
              <VcTooltip title="Unit Group"
                content="Select the unit grouping such as celcius, fahrenheit, kilometers and miles." placement="bottom"
                trigger="hover">
                <a href="#" class="ms-1 text-light opacity-80">
                  <i class="bi bi-question-circle"></i>
                </a>
              </VcTooltip>
            </div>


          </div>
          <div v-if="validLocation" class="col-6 col-md-2">

          </div>
        </div>

        <div v-if="validLocation"
          class="d-flex gap-1 bg-light rounded-bottom py-3 mt-2 mb-2 align-items-center justify-content-center">

          <button type="button" class="btn btn-primary" @click="openAPIDialog">
            <i class="bi bi-code-slash me-2"></i>
            <span class="d-none d-md-inline">Build API Query</span>

          </button>

          <button type="button" class="btn btn-primary" @click="openDownloadDialog()">
            <i class="bi bi-download me-2"></i>
            <span class="d-none d-md-inline">Download Data</span>

          </button>

          <button type="button" class="btn btn-primary 1" @click="openDownloadDialog('schedule')">
            <i class="bi bi-clock me-2"></i>
            <span class="d-none d-md-inline">Schedule</span>

          </button>

          <button type="button" class="btn btn-primary" @click="openDownloadDialog('stats')">
            <i class="bi bi-graph-up me-2"></i>
            <span class="d-none d-md-inline">Statistics</span>

          </button>

          <button v-if="view === 'grid'" type="button" class="btn btn-primary" :class="{ active: view === 'dashboard' }"
            @click="setView('dashboard')" >
            <i class="bi bi-bar-chart-line me-2"></i>
            <span class="d-none d-md-inline" style="min-width:125px">Dashboard</span>
          </button>

          <button v-if="view === 'dashboard'" type="button" class="btn btn-primary"
            :class="{ active: view === 'dashboard' }" @click="setView('grid')" style="min-width:125px">
            <i class="bi bi-grid-3x3 me-2"></i>
              <span class="d-none d-md-inline">Grid</span>
            </button>
        </div>


        <!--
        <div v-else class="">
          <div v-if="validLocation">No data available. Please check your location and date selection.</div>
          <div v-else>No data available. No valid location</div>
        </div>
        -->






        <!-- API Dialog Modal -->
        <template v-if="showAPIDialog">
          <div class="modal-backdrop fade show" @click="closeAPIDialog"></div>

          <div class="modal fade show" style="display: block;" tabindex="-1" aria-labelledby="apiModalLabel"
            aria-modal="true">
            <div class="modal-dialog modal-xl modal-dialog-centered modal-dialog-scrollable">
              <div class="modal-content">
                <div class="modal-header">
                  <h5 class="modal-title" id="apiModalLabel">
                    <i class="bi bi-code-slash text-primary"></i> Weather API
                  </h5>
                  <button type="button" class="btn-close" @click="closeAPIDialog" aria-label="Close"></button>
                </div>

                <div class="modal-body">
                  <p class="bg-light"><i class="bi bi-robot"></i> Generate code for the Weather API in your
                    preferred programming language using our 
                    <a class="btn  btn-primary btn-sm " href="/support/weather-api-ai-code-generator/" target="_blank">
                      <i class="bi bi-robot"></i> AI Code Building Assistant</a></p>

                
                    <!-- Format Selection -->
                    
                    <div class="d-flex flex-md-row flex-wrap justify-content-between mb-3">
                      <!-- Format Selection -->
                      <div class="mb-3 mb-md-0">
                        <div><label class="form-label fw-semibold">Data Format:</label></div>
                        <div class="btn-group btn-group-sm" role="group" aria-label="Content type selection">
                          <button type="button" class="btn btn-outline-primary text-nowrap"
                            :class="{ active: apiQueryDraft.contentType === 'json' }"
                            @click="setContentType(apiQueryDraft, 'json')">
                            <i class="bi bi-braces"></i> JSON
                          </button>
                          <button type="button" class="btn btn-outline-primary text-nowrap"
                            :class="{ active: apiQueryDraft.contentType === 'flatjson' }"
                            @click="setContentType(apiQueryDraft, 'flatjson')">
                            <i class="bi bi-code-square"></i> Flat JSON
                          </button>
                          <button type="button" class="btn btn-outline-primary text-nowrap"
                            :class="{ active: apiQueryDraft.contentType === 'csv' }"
                            @click="setContentType(apiQueryDraft, 'csv')">
                            <i class="bi bi-file-earmark-spreadsheet"></i> CSV
                          </button>
                          <button type="button" class="btn btn-outline-primary text-nowrap"
                            :class="{ active: apiQueryDraft.contentType === 'xlsx' }"
                            @click="setContentType(apiQueryDraft, 'xlsx')">
                            <i class="bi bi-file-earmark-excel"></i> Excel
                          </button>
                        </div>
                        <div class="fs-xs form-text mt-1">
                          <span v-if="apiQueryDraft.contentType === 'json'">
                            <strong>JSON:</strong> Hierarchical format with nested hours/days data
                          </span>
                          <span v-else-if="apiQueryDraft.contentType === 'flatjson'">
                            <strong>Flat JSON:</strong> Flattened single-level JSON structure
                          </span>
                          <span v-else-if="apiQueryDraft.contentType === 'csv'">
                            <strong>CSV:</strong> Comma-separated values for spreadsheet applications
                          </span>
                          <span v-else-if="apiQueryDraft.contentType === 'xlsx'">
                            <strong>Excel:</strong> Native Excel format with multiple worksheets
                          </span>
                        </div>
                      </div>

                      <!-- Data Sections Selection -->
                      <div class="">
                        <div><label class="form-label fw-semibold">Data Sections:</label></div>
                        <div class="btn-group btn-group-sm d-flex flex-nowrap" role="group"
                          aria-label="Data sections selection">
                          <button v-for="section in dataSections" :key="section.id" type="button"
                            class="btn btn-outline-primary text-nowrap" :class="{
                              active: isSectionSelectedIn(apiQueryDraft, section.id),
                            }" @click="toggleSectionIn(apiQueryDraft, section.id)">
                            <i :class="section.icon"></i> {{ section.label }}
                          </button>
                        </div>
                        <div v-if="isSingleSectionOnlyFor(apiQueryDraft)" class="fs-xs form-text mt-1">
                          <i class="bi bi-info-circle"></i>
                          {{ apiQueryDraft.contentType.toUpperCase() }} format supports only one section
                          at a time
                        </div>
                      </div>
                    </div>
                  

                  <!-- API Query URL Display -->
                  <div class="d-flex justify-content-between align-items-center mb-2">
                    <h6 class="mb-0">
                      <i class="bi bi-link-45deg text-primary"></i>
                      Weather API Query URL
                    </h6>
                    <button type="button" class="btn btn-sm btn-outline-primary" @click="copyApiUrl"
                      :title="'Copy Weather API Query URL to clipboard'">
                      <i class="bi bi-clipboard"></i>
                      {{ copyButtonText }}
                    </button>
                  </div>
                  <div class="mb-3">
                    <pre class="p-3 rounded" style="height:150px"><code class="language-http">{{ formattedApiQueryUrl }}</code></pre>
                  </div>

                  <div class="d-flex flex-row mt-3">
                    <div class="text-muted">Use this URL to make requests to the Weather API. </div>
                    

                  </div>

                </div>
              </div>
            </div>
          </div>
        </template>

        <template v-if="showLocationsDialog">
          <div class="modal-backdrop fade show"></div>
          <div class="modal fade show" style="display: block;" tabindex="-1" aria-labelledby="processingModalLabel"
            aria-modal="true">

            <div class="modal-dialog modal-xl modal-dialog-centered modal-dialog-scrollable">
              <div class="modal-content">
                <div class="modal-header">
                  <h5 class="modal-title" id="processingModalLabel">Locations</h5>
                  <button type="button" class="btn-close" @click="closeLocationsDialog()" aria-label="Close"></button>
                </div>
                <div class="modal-content" style="min-height: 400px; max-height: 90vh;">
                  <LocationsEditor :parentLocations="locationsDraft" :subscriptionParams="subscriptionParams"
                    @locationsChanged="handleLocationsChanged">
                  </LocationsEditor>
                </div>

                <div class="d-flex gap-2 flex-row justify-content-end p-3">

                  <button type="button" class="btn btn-secondary" @click="closeLocationsDialog()">
                    Cancel
                  </button>
                  <button type="button" class="btn btn-primary" :disabled="!validLocationChanges"
                    @click="applyLocationChanges()">
                    Save Changes
                  </button>
                </div>
              </div>
            </div>
          </div>
        </template>

        <template v-if="showMyDatasetsDialog">
          <div class="modal-backdrop fade show"></div>
          <div class="modal fade show" style="display: block;" tabindex="-1" aria-labelledby="processingModalLabel"
            aria-modal="true">

            <div class="modal-dialog modal-dialog-centered modal-xl">
              <div class="modal-content">
                <div class="modal-header">
                  <h5 class="modal-title" id="processingModalLabel">Your saved datasets</h5>
                  <button type="button" class="btn-close" @click="closeMyDatasetsDialog" aria-label="Close"></button>
                </div>
                <div class="modal-body">
                  <div class="row mt-0 mb-0 bg-primary text-light rounded-top py-2">
                    <div class="fw-bold my-2">Your saved datasets</div>
                    <div id="locationHelpBlock" class="form-text text-light mt-0 mb-1 opacity-70 ">
                      Download and edit datasets that you have already run.
                      <VcTooltip title="Saved datasets" content="Download your data as CSV, Excel or JSON files."
                        placement="bottom" trigger="hover">
                        <a href="#" class="ms-1 text-light opacity-80">
                          <i class="bi bi-question-circle"></i>
                        </a>
                      </VcTooltip>
                    </div>
                  </div>
                  <BulkDefinitionsList :sessionId="sessionId" :sessionState="sessionState" @select:task="setMetadata">
                  </BulkDefinitionsList>
                </div>
              </div>
            </div>
          </div>
        </template>

        <!-- Download Dialog Modal -->

        <DownloadDialog 
          v-if="showDownloadDialog"
          :package-defn="packageDefn"
          :session-id="sessionId"
          :session-state="sessionState"
          :initial-mode="downloadDialogMode"
          :metadata="metadata"
          :selected-location="selectedLocation"
          :subscription-params="subscriptionParams"
          :usage-info="usageInfo"
          :initial-grid-view="gridView"
          @close="closeDownloadDialog"
          @saved="handlePackageSaved"
          @open-my-datasets="openMyDatasetsDialog"
          @refresh-usage="refreshUsageInfo"
          @open-sign-in="showSignIn"
          @open-sign-up="showSignUpDialog"
        />
         <!--
        <template v-if="showDownloadDialog">
          <div class="modal-backdrop fade show" @click="closeDownloadDialog"></div>

          <div class="modal fade show" style="display: block;" tabindex="-1" aria-labelledby="downloadModalLabel"
            aria-modal="true">
            <div class="modal-dialog modal-xl modal-dialog-centered modal-dialog-scrollable">
              <div class="modal-content" style="min-height: 90vh; max-height: 90vh;">
                <div class="modal-header">
                  <h5 class="modal-title" id="downloadModalLabel">
                    <i class="bi bi-download text-primary"></i> Download Weather Data
                  </h5>
                  <button type="button" class="btn-close" @click="closeDownloadDialog" aria-label="Close"></button>
                </div>

                <div class="modal-body d-flex flex-column previewTarget"
                  style="height: calc(800px - 120px); overflow: hidden;">

                  <template v-if="downloadStep === 0" class="d-flex flex-column h-100">
                   
                    <div class="d-flex flex-md-row flex-wrap justify-content-between mb-3">
                    
                      <div class="mb-3 mb-md-0">
                        <div><label class="form-label fw-semibold">Data Format:</label></div>
                        <div class="btn-group btn-group-sm" role="group" aria-label="Content type selection">
                          <button type="button" class="btn btn-outline-primary text-nowrap"
                            :class="{ active: downloadQueryDraft.contentType === 'json' }"
                            @click="setContentType(downloadQueryDraft, 'json')">
                            <i class="bi bi-braces"></i> JSON
                          </button>
                          <button type="button" class="btn btn-outline-primary text-nowrap"
                            :class="{ active: downloadQueryDraft.contentType === 'flatjson' }"
                            @click="setContentType(downloadQueryDraft, 'flatjson')">
                            <i class="bi bi-code-square"></i> Flat JSON
                          </button>
                          <button type="button" class="btn btn-outline-primary text-nowrap"
                            :class="{ active: downloadQueryDraft.contentType === 'csv' }"
                            @click="setContentType(downloadQueryDraft, 'csv')">
                            <i class="bi bi-file-earmark-spreadsheet"></i> CSV
                          </button>
                          <button type="button" class="btn btn-outline-primary text-nowrap"
                            :class="{ active: downloadQueryDraft.contentType === 'xlsx' }"
                            @click="setContentType(downloadQueryDraft, 'xlsx')">
                            <i class="bi bi-file-earmark-excel"></i> Excel
                          </button>
                        </div>
                        <div class="fs-xs form-text mt-1">
                          <span v-if="downloadQueryDraft.contentType === 'json'">
                            <strong>JSON:</strong> Hierarchical format with nested hours/days data
                          </span>
                          <span v-else-if="downloadQueryDraft.contentType === 'flatjson'">
                            <strong>Flat JSON:</strong> Flattened single-level JSON structure
                          </span>
                          <span v-else-if="downloadQueryDraft.contentType === 'csv'">
                            <strong>CSV:</strong> Comma-separated values for spreadsheet applications
                          </span>
                          <span v-else-if="downloadQueryDraft.contentType === 'xlsx'">
                            <strong>Excel:</strong> Native Excel format with multiple worksheets
                          </span>
                        </div>
                      </div>

                     
                      <div class="">
                        <div><label class="form-label fw-semibold">Data Sections:</label></div>
                        <div class="btn-group btn-group-sm d-flex flex-nowrap" role="group"
                          aria-label="Data sections selection">
                          <button v-for="section in dataSections" :key="section.id" type="button"
                            class="btn btn-outline-primary text-nowrap" :class="{
                              active: isSectionSelectedIn(downloadQueryDraft, section.id),
                            }" @click="toggleSectionIn(downloadQueryDraft, section.id)">
                            <i :class="section.icon"></i> {{ section.label }}
                          </button>
                        </div>
                        <div v-if="isSingleSectionOnlyFor(downloadQueryDraft)" class="fs-xs form-text mt-1">
                          <i class="bi bi-info-circle"></i>
                          {{ downloadQueryDraft.contentType.toUpperCase() }} format supports only one section
                          at a time
                        </div>
                      </div>
                    </div>
                  
                    <div class="mb-4 bg-light border rounded px-2 py-3">
                      <div>

                        <div class="d-flex flex-row align-items-center justify-content-between my-2">
                          <div><strong>Estimated total cost: {{ queryMeteredCostDetails }}. </strong> </div>
                          <div class="form-text">
                            <a href="/resources/documentation/weather-data/what-exactly-is-a-weather-record/"
                              target="_blank">What
                              exactly is a weather record?</a>
                          </div>
                        </div>

                        <div class="fs-xs form-text ">Each location costs {{ estimateQueryCost }}. Total location
                          count: {{ locationCount }}.
                          <a href="#" @click.prevent="showCostBreakdown = !showCostBreakdown">
                           
                            {{ showCostBreakdown ? 'Hide' : 'Show' }} details
                            </a>
                        </div>
                      </div>

                      <div v-if="!hasSession" class="mt-3">
                      
                        <div class="form-text">Prices for this download will range start at ${{ estimateQueryCost *
                          0.0001 }} for our metered plan.
                          Our monthly and annual plans allow for even more affordable query cost. </div>
                      </div>

                      <div v-else-if="isMetered" class="mt-3">
                        Used record cost: {{ currentDailyCost }}.
                        Free record count remaining: {{ remainingFreeDailyCost }}
                      </div>

                      <div v-else class="d-flex flex-wrap gap-3 mt-3 align-items-center">
                        <div class="d-flex align-items-center gap-2">
                          <small class="text-muted">Today:</small>
                          <div class="progress position-relative" style="width: 120px; height: 20px;">
                            <div class="progress-bar" role="progressbar"
                              :style="{ width: Math.max(dailyUsagePercent, 2) + '%' }" :class="dailyUsageClass">
                             
                              <small v-if="dailyUsagePercent > 20" class="fw-bold">
                                {{ formatCompactNumber(currentDailyCost) }}
                              </small>
                            </div>
                            
                            <div v-if="dailyUsagePercent <= 20" class="position-absolute w-100 text-center"
                              style="line-height: 20px;">
                              <small class="fw-bold text-dark">{{ formatCompactNumber(currentDailyCost) }}</small>
                            </div>
                          </div>
                          <small class="text-muted">/ {{ formatCompactNumber(dailyCostLimit) }}</small>
                        </div>

                        <div class="d-flex align-items-center gap-2">
                          <small class="text-muted">Period:</small>
                          <div class="progress position-relative" style="width: 120px; height: 20px;">
                            <div class="progress-bar" role="progressbar"
                              :style="{ width: Math.max(monthlyUsagePercent, 2) + '%' }" :class="monthlyUsageClass">
                             
                              <small v-if="monthlyUsagePercent > 20" class="fw-bold">
                                {{ formatCompactNumber(currentMonthlyCost) }}
                              </small>
                            </div>
                           
                            <div v-if="monthlyUsagePercent <= 20" class="position-absolute w-100 text-center"
                              style="line-height: 20px;">
                              <small class="fw-bold text-dark">{{ formatCompactNumber(currentMonthlyCost) }}</small>
                            </div>
                          </div>
                          <small class="text-muted">/ {{ formatCompactNumber(monthlyCostLimit) }}</small>
                        </div>
                      </div>

                      <div v-if="exceedsLimit" class="alert alert-danger mt-3" role="alert" v-html="exceedsLimitMsg">
                      </div>

                      <div v-if="isExtendedDataset" class="alert alert-warning  mt-3" role="alert">
                        This is a extended dataset and will take multiple days to run. This query cannot be
                        scheduled or downloaded via the Datasets API.
                        Please track your query progress in <a href="#" class="text-primary text-decoration-underline"
                          @click="openMyDatasetsDialog()">My
                          Datasets</a>
                        where you can download the results when they are finished.
                      </div>

                      <div v-else-if="largeDataset" class="alert alert-warning  mt-3" role="alert">
                        This is a large dataset and may take multiple hours to run. Please track your query progress
                        in <a href="#" class="text-primary text-decoration-underline" @click="openMyDatasetsDialog()">My
                          Datasets</a> where you can download the results when they are finished.
                      </div>


                     
                      <div v-if="showCostBreakdown"
                        ref="costBreakdownContainer"
                        class="cost-breakdown-container mt-3"
                        :class="{ 'maximized': costBreakdownMaximized }">
                        <div class="card h-100">
                        <div class="card-header bg-light d-flex justify-content-between align-items-center">
                          <h6 class="mb-0">
                            <i class="bi bi-calculator me-2"></i>Detailed Cost Breakdown
                          </h6>
                        </div>
                          <div class="card-body">
                            <div class="table-responsive">
                              <table class="table table-sm table-hover fs-sm">
                                <tbody>
                                 
                                  <tr v-if="detailedQueryCost.queryStartDate">
                                    <td class="text-muted">Query Start Date</td>
                                    <td class="text-end">{{ formatDate(detailedQueryCost.queryStartDate) }}</td>
                                  </tr>
                                  <tr v-if="detailedQueryCost.queryEndDate">
                                    <td class="text-muted">Query End Date</td>
                                    <td class="text-end">{{ formatDate(detailedQueryCost.queryEndDate) }}</td>
                                  </tr>

                                  
                                  <tr class="table-active">
                                    <td colspan="2"><strong>Data Periods</strong></td>
                                  </tr>
                                  <tr>
                                    <td class="text-muted ps-3">Total Days</td>
                                    <td class="text-end">{{ detailedQueryCost.totalDays || 0 }}</td>
                                  </tr>
                                  <tr v-if="detailedQueryCost.hasDays">
                                    <td class="text-muted ps-3">Daily Records</td>
                                    <td class="text-end">{{ detailedQueryCost.totalDays || 0 }}</td>
                                  </tr>
                                  <tr v-if="detailedQueryCost.hasHours">
                                    <td class="text-muted ps-3">Total Hours</td>
                                    <td class="text-end">{{ detailedQueryCost.totalHours || 0 }}</td>
                                  </tr>
                                  <tr v-if="detailedQueryCost.hasMinutes">
                                    <td class="text-muted ps-3">Total Minutes ({{ detailedQueryCost.minuteInterval
                                      || 15 }} min intervals)</td>
                                    <td class="text-end">{{ detailedQueryCost.totalMinutes || 0 }}</td>
                                  </tr>

                                 
                                  <tr class="table-active">
                                    <td colspan="2"><strong>Cost Analysis</strong></td>
                                  </tr>

                                  
                                  <tr v-if="detailedQueryCost.freeForecastStartDate">
                                    <td class="text-muted ps-3">Free Forecast Period</td>
                                    <td class="text-end small">
                                      {{ formatDate(detailedQueryCost.freeForecastStartDate) }} -
                                      {{ formatDate(detailedQueryCost.freeForecastEndDate) }}
                                    </td>
                                  </tr>

                                  
                                  <tr v-if="detailedQueryCost.freeDaysUsed > 0" class="table-success">
                                    <td class="text-muted ps-3">
                                      <i class="bi bi-check-circle text-success me-1"></i>
                                      Free Days Used
                                    </td>
                                    <td class="text-end">{{ detailedQueryCost.freeDaysUsed || 0 }}</td>
                                  </tr>
                                  <tr v-if="detailedQueryCost.freeHoursUsed > 0 && detailedQueryCost.hasHours"
                                    class="table-success">
                                    <td class="text-muted ps-3">
                                      <i class="bi bi-check-circle text-success me-1"></i>
                                      Free Hours
                                    </td>
                                    <td class="text-end">{{ detailedQueryCost.freeHoursUsed || 0 }}</td>
                                  </tr>
                                  <tr v-if="detailedQueryCost.freeMinutesUsed > 0 && detailedQueryCost.hasMinutes"
                                    class="table-success">
                                    <td class="text-muted ps-3">
                                      <i class="bi bi-check-circle text-success me-1"></i>
                                      Free Minutes
                                    </td>
                                    <td class="text-end">{{ detailedQueryCost.freeMinutesUsed || 0 }}</td>
                                  </tr>

                                 
                                  <tr v-if="detailedQueryCost.paidDaysUsed > 0" class="table-warning">
                                    <td class="text-muted ps-3">
                                      <i class="bi bi-credit-card text-warning me-1"></i>
                                      Paid Days
                                    </td>
                                    <td class="text-end">{{ detailedQueryCost.paidDaysUsed || 0 }}</td>
                                  </tr>
                                  <tr v-if="detailedQueryCost.paidHoursUsed > 0 && detailedQueryCost.hasHours"
                                    class="table-warning">
                                    <td class="text-muted ps-3">
                                      <i class="bi bi-credit-card text-warning me-1"></i>
                                      Paid Hours
                                    </td>
                                    <td class="text-end">{{ detailedQueryCost.paidHoursUsed || 0 }}</td>
                                  </tr>
                                  <tr v-if="detailedQueryCost.paidMinutesUsed > 0 && detailedQueryCost.hasMinutes"
                                    class="table-warning">
                                    <td class="text-muted ps-3">
                                      <i class="bi bi-credit-card text-warning me-1"></i>
                                      Paid Minutes
                                    </td>
                                    <td class="text-end">{{ detailedQueryCost.paidMinutesUsed || 0 }}</td>
                                  </tr>

                                  
                                  <tr class="table-primary">
                                    <td>
                                      <strong>Total Estimated Records</strong>
                                    </td>
                                    <td class="text-end">
                                      <strong>{{ detailedQueryCost.estimatedCost || estimateQueryCost || 0
                                      }}</strong>
                                    </td>
                                  </tr>

                                 
                                  <tr v-if="isMetered" class="table-primary">
                                    <td>
                                      <strong>Estimated Cost</strong>
                                    </td>
                                    <td class="text-end">
                                      <strong>${{ ((detailedQueryCost.estimatedCost || estimateQueryCost || 0) *
                                        0.0001).toFixed(4) }}</strong>
                                    </td>
                                  </tr>


                                  <tr v-else-if="detailedQueryCost.paidDaysUsed > 0" class="table-info">
                                    <td colspan="2" class="text-center">
                                      <i class="bi bi-info-circle-fill text-info me-2"></i>
                                      <small>This query includes {{ detailedQueryCost.paidDaysUsed }} days of
                                        historical/extended forecast data</small>
                                    </td>
                                  </tr>
                                </tbody>
                              </table>
                            </div>

                           
                            <div class="alert alert-light mt-3 mb-0">
                              <small>
                                <i class="bi bi-info-circle me-1"></i>
                                <strong>Note:</strong>
                                Free forecast includes {{ detailedQueryCost.freeForecastDays || 15 }} days from
                                today.
                                Historical data and extended forecasts consume credits from your account.
                              </small>
                            </div>
                          </div>
                        </div>
                      </div>




                    </div>





                    <DownloadPreviewer :sessionState="sessionState" :queryDefinition="downloadQueryDraft"
                      :location="selectedLocation" :costSaverMode="true" :maximize-target="'.previewTarget'"
                      class="flex-fill mb-3"></DownloadPreviewer>

                  
                    <div class="d-flex justify-content-between mt-auto">
                      <div v-if="downloadStepErrorMessage" class="text-danger" role="alert">
                        <i class="bi bi-exclamation-diamond"></i> {{ downloadStepErrorMessage }}
                      </div>
                      <button type="button" class="ms-auto btn btn-primary" :disabled="downloadStepErrorMessage"
                        @click="downloadStep = 1">
                        Next <i class="bi bi-chevron-right"></i>
                      </button>
                    </div>


                  </template>

                  <div v-if="downloadStep === 1" class="d-flex flex-column flex-fill">

                    <template v-if="notStarted">

                      <template v-if="metadata.id">
                        <h6 class="h6 mb-3">Your dataset is ready to run</h6>
                        <p class="text-muted">Hit 'Run dataset' to start execution.</p>
                      </template>


                      <template v-else>
                        <h6 class="h6 mb-3">Create a New Download Dataset</h6>
                        <p class="text-muted">Save your download settings for future use.</p>

                        <div class="card">
                          <div class="card-body">
                            <div style="max-width: 600px;">
                              <label for="package-name" class="form-label text-dark"><strong>Enter a dataset name</strong></label>
                              <div class="input-group">
                                <input class="form-control" type="text" id="package-name" v-model="packageName"
                                  :placeholder="defaultName(downloadPackageDraft)" ref="nameInput"
                                  @keyup.enter="saveMetadataChanges">
                                  
                              </div>
                               <div class="form-text">
                                This name can be used to retrieved the saved dataset later.
                               </div>
                              
                            </div>  
                          </div>
                        </div>
                      </template>

                      <template v-if="bulkAllowSubscription && subscriptionMode">
                        <div class="card mb-4 shadow-sm">
                          <div class="card-header bg-primary ">
                            <h6 class="mb-0 text-light"><i class="bi bi-clock me-2"></i>Scheduled Dataset</h6>
                          </div>
                          <div class="card-body">
                            <label class="form-label">Run Times (UTC)</label>
                            <div v-for="(time, idx) in downloadPackageDraft.runTimes" :key="idx"
                              class="input-group mb-2" style="max-width: 260px;">
                              <select class="form-select" :value="getHour(time)"
                                @change="setRunTimeHour(downloadPackageDraft, idx, $event.target.value)">
                                <option v-for="hour in 24" :key="hour" :value="hour - 1">
                                  {{ String(hour - 1).padStart(2, '0') }}
                                </option>
                              </select>
                              <span class="input-group-text">:</span>
                              <select class="form-select" :value="getMinute(time)"
                                @change="setRunTimeMinute(downloadPackageDraft, idx, $event.target.value)">
                                <option v-for="min in [0, 15, 30, 45]" :key="min" :value="min">
                                  {{ String(min).padStart(2, '0') }}
                                </option>
                              </select>
                              <button type="button" class="btn btn-outline-danger"
                                @click="removeRunTime(downloadPackageDraft, idx)">
                                <i class="bi bi-trash"></i>
                              </button>
                            </div>
                            <div v-if="!downloadPackageDraft.runTimes || downloadPackageDraft.runTimes.length === 0">
                              <p>No scheduled times</p>
                            </div>
                            <button type="button" class="btn btn-outline-primary btn-sm mb-3"
                              @click="addRunTime(downloadPackageDraft)">
                              <i class="bi bi-plus-circle"></i> Add Time
                            </button>
                            <div class="form-check mb-2">
                              <input v-model="downloadPackageDraft.enabled" class="form-check-input" type="checkbox"
                                id="enabled">
                              <label class="form-check-label" for="enabled">Enabled</label>
                            </div>
                            <div class="form-check mb-2">
                              <input v-model="downloadPackageDraft.runOnce" class="form-check-input" type="checkbox"
                                id="runOnce">
                              <label class="form-check-label" for="runOnce">Run immediately</label>
                            </div>
                          </div>
                        </div>
                      </template>
                    
                    </template>

                    <div>
                      <div v-if="savePackageErrorMessage" class="alert alert-danger mt-3" role="alert">
                        {{ savePackageErrorMessage }}
                      </div>
                    </div>
                    <div>
                      <div v-if="invalidPackageMessage(downloadPackageDraft)" class="alert alert-warning mt-3"
                        role="alert">
                        {{ invalidPackageMessage(downloadPackageDraft) }}
                      </div>
                    </div>

                    <div v-if="pollingState.isRefreshingResults">
                      <div class="d-flex align-items-center">
                        <div class="spinner-border mx-2 me-3" role="status" aria-hidden="true"></div>
                        <strong>{{ processingStatusText }}</strong>

                      </div>
                      <div v-if="didYouKnowTip" class="mt-4">
                        <strong>Did you know? </strong>
                        {{ didYouKnowTip.label }}
                        <a href="#" class="text-primary" @click.prevent.stop="openDidYouKnow(didYouKnowTip)">
                          Learn more
                        </a>
                      </div>
                    </div>
                    <div v-else-if="hasResultError">
                      <strong>Error:</strong> {{ taskInstance.errorMessage }}
                    </div>

                    <div v-else-if="taskInstance" class="mt-3">
                   
                      <div class="card">
                        <div class="card-header bg-light d-flex justify-content-between align-items-center">
                          <template v-if="hasResult">
                            <h6 class="mb-0">
                              <i class="bi bi-check-circle-fill text-success me-2"></i>
                              Download Complete
                            </h6>
                            <span class="badge bg-success">Ready</span>
                          </template>
                          <template v-if="hasExpired">
                            <h6 class="mb-0">
                              <i class="bi bi-x-circle-fill text-warning me-2"></i>
                              Last result expired
                            </h6>
                            <span class="badge bg-warning">Expired</span>
                          </template>
                          <template v-if="hasResultError">
                            <h6 class="mb-0">
                              <i class="bi bi-x-circle-fill text-danger me-2"></i>
                              Last result error
                            </h6>
                            <span class="badge bg-danger">Error</span>
                          </template>
                          <template v-if="isProcessing">
                            <h6 class="mb-0">
                              <i class="bi bi-x-circle-fill text-info me-2"></i>
                              Result is processing
                            </h6>
                            <span class="badge bg-info">Processing</span>
                          </template>
                        </div>

                        <div class="card-body">
                        
                          <div class="row g-1 mb-4">
                            <div class="col-md-6">
                              <div class="d-flex justify-content-between align-items-center p-2 bg-light rounded">
                                <span class="text-muted">Completed Locations:</span>
                                <strong>{{ taskInstance.completed }} / {{ taskInstance.total }}</strong>
                              </div>
                            </div>
                          
                            <div class="col-md-6">
                              <div class="d-flex justify-content-between align-items-center p-2 bg-light rounded">
                                <span class="text-muted">Format:</span>
                                <strong>{{ taskInstance.contentType?.toUpperCase() || 'N/A' }}</strong>
                              </div>
                            </div>

                            <div v-if="taskInstance.info" class="col-12">
                              <div class="p-2 bg-light rounded">
                                <span class="text-muted d-block mb-1">Additional Info:</span>
                                <small>{{ taskInstance.info }}</small>
                              </div>
                            </div>
                          </div>

                         
                          <div class="row g-3 mb-4">
                            <div class="col-md-6">
                              <small class="text-muted d-block">Completed At</small>
                              <div class="fw-semibold">
                                <i class="bi bi-calendar-check me-1"></i>
                                {{ formatDateTime(taskInstance.endDatetime) }}
                              </div>
                            </div>

                            <div class="col-md-6">
                              <small class="text-muted d-block">Expires</small>
                              <div class="fw-semibold">
                                <i class="bi bi-hourglass-split me-1"></i>
                                {{ formatDateTime(taskInstance.expirationDateTime) }}
                              </div>
                            </div>
                          </div>
                          <template v-if="hasResult">
                           
                            <div class="d-flex gap-2 mb-4">
                              <button type="button" class="btn btn-primary" @click="downloadResult(metadata)">
                                <i class="bi bi-download me-2"></i>
                                Download File
                              </button>
                            </div>

                         
                            <div v-if="metadata && metadata.id" class="border-top pt-3">
                              <h6 class="text-muted mb-3">
                                <i class="bi bi-link-45deg me-1"></i>
                                Direct Links to Your Dataset
                              </h6>

                              <div class="d-flex flex-wrap gap-2 mb-3">
                                <button v-if="!requiresZipResult(downloadPackageDraft)" type="button"
                                  class="btn btn-outline-dark btn-sm" @click="copyLink(textResultsUri, $event)">
                                  <i class="bi bi-clipboard me-1"></i>
                                  {{ taskInstance.contentType?.toUpperCase() || 'Data' }} Link
                                </button>

                                <button type="button" class="btn btn-outline-dark btn-sm"
                                  @click="copyLink(zipResultsUri, $event)">
                                  <i class="bi bi-file-earmark-zip me-1"></i>
                                  ZIP Archive Link
                                </button>
                              </div>

                              <div class="alert alert-info alert-sm">
                                <i class="bi bi-info-circle me-1"></i>
                                <small>Use these links to import data directly into databases, Excel, Google Sheets,
                                  or other tools.</small>
                              </div>
                            </div>
                          </template>

                        </div>
                      </div>
                    </div>


                    
                    <div class="mt-auto d-flex flex-column">
                      <div v-if="showConfirmOverwrite" class="alert alert-warning mt-3" role="alert">
                        A package with the name "<strong>{{ currentName(packageDefn) }}</strong>" already
                        exists. Do you want to
                        overwrite it?
                        <div class="mt-2">
                          <button type="button" class="btn btn-sm btn-primary me-2"
                            @click="confirmOverwritePackage(packageDefn)">Yes, Overwrite</button>
                          <button type="button" class="btn btn-sm btn-secondary"
                            @click="showConfirmOverwrite = false">Cancel</button>
                        </div>
                      </div>
                      <div v-if="notStarted" class="d-flex align-items-end justify-content-end  gap-2">


                                            
                        <div v-if="confirmationMessage">
                          <div class="alert alert-success me-auto" role="alert">
                            {{ confirmationMessage }}
                          </div>
                        </div>

                        <template v-else>
                         
                          <button v-if="!subscriptionMode" type="button" class="btn btn-primary" 
                                @click="runPackageNow(downloadPackageDraft)"
                                :disabled="!isPackageValid(downloadPackageDraft) || isSaving || showConfirmOverwrite">
                                <span v-if="isSaving && !downloadPackageDraft.runTimes?.length"
                                  class="spinner-border spinner-border-sm me-2" role="status"></span>
                                <i v-else class="bi bi-save me-1"  ></i>
                                Download
                          </button>

                          <button v-if="subscriptionMode" type="button" class="btn" :class="{ 'btn-primary': !hasResult, 'btn-secondary': hasResult }"
                                @click="saveScheduledPackage(downloadPackageDraft)"
                                :disabled="!(isPackageValid(downloadPackageDraft)) || !downloadPackageDraft.runTimes?.length || isSaving || showConfirmOverwrite">
                                <span v-if="isSaving && downloadPackageDraft.runTimes?.length"
                                  class="spinner-border spinner-border-sm me-2" role="status"></span>
                                <i v-else class="bi bi-clock me-1"></i>
                                {{ !metadata.id ? 'Schedule' : 'Save & Schedule' }}
                          </button>

          
                          <button v-if="hasResult" type="button" class="btn btn-primary" @click="downloadResult(metadata)">
                              <i class="bi bi-download me-2"></i>
                              Download File
                          </button>
                      
                          



                        
                          
                        </template>

                      </div>
                      </div>

                  </div>

                  <div v-if="downloadStep === 2" class="d-flex flex-column flex-fill">
                    <WeatherStatisticsEditor :packageDefn="downloadPackageDraft" :sessionId="sessionId"
                      :sessionState="sessionState" :value="{ goal: 'timeline' }"
                      @update:statsdefinition="(statsDefn) => updateStatsDefinition(statsDefn, downloadPackageDraft)">
                    </WeatherStatisticsEditor>

                    <div class="d-flex align-items-end justify-content-end mt-auto gap-2">
                      <button type="button" class="ms-auto btn btn-primary"
                        :disabled="downloadStepErrorMessage || !hasValidWeatherStatsDefn(downloadPackageDraft)"
                        @click="downloadStep = 1">
                        Next <i class="bi bi-chevron-right"></i>
                      </button>
                    </div>
                  </div>

                </div>
              </div>
            </div>
          </div>
        </template>
      -->


        <div v-if="hasNoLocations" class="">
          <h5>Please add a location to get started</h5>

          <div class="input-group">
            <div class="btn px-1 disabled">
              <i class="bi bi-geo"></i>
            </div>
            <input v-model="newLocation" v-on:keyup.enter="addLocation()"
              class="form-control border-end-0  border-primary" type="text" placeholder="Enter a location"
              aria-describedby="locationHelpBlock">
            <span class="input-group-append">
              <button @click="addLocation()" class="btn btn-primary  border-start-0 border-primary ms-n1"
                :class="{ disabled: !newLocation }" type="button">
                <i class="bi bi-search"></i>
              </button>
            </span>
          </div>

          <div id="locationHelpBlock" class="form-text  my-1">
            Addresses, partial addresses or latitude,longitude values.
          </div>

          <div class="ps-1 pt-1"><a href="#" @click.prevent.stop="findMyLocation()"><i class="bi bi-broadcast-pin"></i>
              Use
              your location</a></div>
        </div>
        <template v-else-if="view === 'dashboard'">
          <div v-if="costSaverMode" class="alert alert-info">
            <i class="bi bi-info-circle me-1"></i>
            <span v-if="!hasSession">Chart data may be incomplete. Please sign in to view full data.</span>

            <span v-else>Chart data may be incomplete. Enable full data mode to view full data.
              <button v-if="hasSession" type="button" class="btn btn-sm text-primary px-1 py-0"
                @click="changeCostSaver(!costSaverMode)">
                <template v-if="costSaverMode">
                  <span><i class="bi bi-speedometer2"></i><span class="d-none d-lg-inline"> Full data
                      mode</span></span>
                </template>
                <template v-else>
                  <span><i class="bi bi-turtle"></i><span class="d-none d-lg-inline"> Preview mode</span></span>
                </template>
              </button>
            </span>
          </div>
          <div v-if="errorMessage" class="alert alert-danger my-3" role="alert">
            <i class="bi bi-exclamation-diamond"></i> {{ errorMessage }}
          </div>
          <WeatherChartDashboard :packageDefn="packageDefn" :sessionId="sessionId" :sessionState="sessionState"
            :weather-data="resultData" :unit-group="queryDefn.unitGroup"
            @package-updated="handleDashboardPackageUpdated" />

        </template>


        <!-- Grid View - Integrated directly -->
        <div v-else-if="view === 'grid'" class="flex-fill">
          <!-- Show error if no data for selected view -->
          <!-- Grid Header Controls -->
          <div class="row justify-content-between align-items-center mb-2">
            <div class="col-md-6 d-flex align-items-center gap-2">
              <div class="btn-group btn-group-sm" role="group">
                <button type="button" class="btn btn-outline-primary" :class="{ active: gridView === 'days' }"
                  @click="setGridView('days')">
                  <i class="bi bi-calendar3"></i> Daily
                </button>
                <button type="button" class="btn btn-outline-primary" :class="{ active: gridView === 'hours' }"
                  @click="setGridView('hours')">
                  <i class="bi bi-clock"></i> Hourly
                </button>
                <button type="button" class="btn btn-outline-primary" :class="{ active: gridView === 'minutes' }"
                  @click="setGridView('minutes')">
                  <i class="bi bi-clock"></i> Minute
                </button>
                <button type="button" class="btn btn-outline-primary" :class="{ active: gridView === 'current' }"
                  @click="setGridView('current')">
                  <i class="bi bi-hourglass"></i> Current
                </button>
                <button type="button" class="btn btn-outline-primary" :class="{ active: gridView === 'events' }"
                  @click="setGridView('events')">
                  <i class="bi bi-tornado"></i> Events
                </button>
                <button type="button" class="btn btn-outline-primary" :class="{ active: gridView === 'alerts' }"
                  @click="setGridView('alerts')">
                  <i class="bi bi-exclamation-triangle"></i> Alerts
                </button>
                <button type="button" class="btn btn-outline-primary" :class="{ active: gridView === 'queryInfo' }"
                  @click="setGridView('queryInfo')">
                  <i class="bi bi bi-info-circle"></i> Info
                </button>
              </div>
            </div>
            
            <div class="col-md-6 d-flex justify-content-end gap-2">
                <!-- Add the checkbox for current section -->
              <div v-if="gridView !== 'queryInfo'" class="form-check form-switch d-flex align-items-center me-2">
                
                <input 
                  class="form-check-input mt-0" 
                  type="checkbox" 
                  :id="`include-${gridView}`"
                  :checked="isCurrentGridViewInQuery"
                  :disabled="gridView === 'days'"
                  @change="toggleSectionQuery(gridView)">
                <label class="form-check-label ms-2 mb-0 fs-sm" :for="`include-${gridView}`">
                  Include in query 
                </label>
              </div>
              <button v-if="hasSession" type="button" class="btn btn-sm text-primary px-1 py-0"
                @click="changeCostSaver(!costSaverMode)">
                <template v-if="costSaverMode">
                  <span><i class="bi bi-speedometer2"></i><span class=""> Full data mode</span></span>
                </template>
                <template v-else>
                  <span><i class="bi bi-speedometer"></i><span class=""> Preview mode</span></span>
                </template>
              </button>
              <button type="button" class="btn btn-link btn-sm" @click="openElementsPickerForGroup(null)"><i
                  class="bi bi-ui-checks-grid"></i> Elements
                </button>
            </div>
          </div>
          <div v-if="errorMessage" class="alert alert-danger my-3" role="alert">
            <i class="bi bi-exclamation-diamond"></i> {{ errorMessage }}
          </div>
          <div v-else-if="!gridData || gridData.length === 0" class="alert alert-info">
            <i class="bi bi-info-circle me-1"></i>
            <span v-if="gridView === 'events'">
              No weather events found for this location and time period. 
              Weather events are shown only when significant events occurred near the selected location, 
              typically within the first few days of the query range. In preview mode, only the first few rows 
              are retrieved, so some events may not appear.
            </span>
            <span v-else-if="gridView === 'alerts'">
                No active weather alerts for this location. 
                Alerts are displayed only when an active alert exists for the specified location and the query 
                includes the current forecast period.
            </span>
            <span v-else-if="gridView === 'current'">Current conditions not available. Current conditions are included when the query request includes 'today'.</span>
            <span v-else-if="gridView === 'minutes' && !hasMinutes">Minute data not included in query. Please enable 'Include in query' to enable it.</span>
            <span v-else-if="gridView === 'hours' && !hasHours">Hourly data not included in query. Please enable 'Include in query' to enable it.</span>
            <span v-else>No data available for the selected view. Click 'Include in query' to include this data section.</span>
          </div>
          <div v-else-if="gridView === 'alerts'">
             <h5>Weather Alerts</h5>
             <div v-for="(row, index) in gridData" :key="index" class="col-12">
              <div class="card ">
                <div class="card-header bg-opacity-10 ">
                  <h6 class="mb-0 text-dark fw-bold">
                    
                    {{ row.event }}
                  </h6>
                </div>
                <div class="card-body">
                  <!-- Primary Information -->
                  <p class="mb-2 fw-semibold">{{ row.headline }}</p>
                  
                  <!-- Time Information -->
                  <div class="row g-2 mb-3">
                    <div class="col-md-6">
                      <small class="text-muted">Onset:</small>
                      <div class="fw-medium">{{ formatDateTime(row.onset) || 'Not specified' }}</div>
                    </div>
                    <div class="col-md-6">
                      <small class="text-muted">Ends:</small>
                      <div class="fw-medium">{{ formatDateTime(row.ends) || 'Not specified' }}</div>
                    </div>
                  </div>
                  
                  
                  <div class="border-top pt-2">

                    <p class="small text-muted mb-2">{{ row.description }}</p>
                    <!-- Alert ID - Least prominent -->
                    <div class="text-end">
                      <small class="text-muted opacity-50">ID: {{ row.id }}</small>
                    </div>

                  </div>
                </div>
              </div>
            </div>
          </div>
          <div v-else-if="gridView === 'events'">
             <h5>Weather Events</h5>
             <div v-for="(row, index) in gridData" :key="index" class="col-12 mb-3">
              <div class="card ">
                <div class="card-header bg-opacity-10 ">
                  <h6 class="mb-0 text-dark fw-bold">
                    
                    {{ row.type }}
                  </h6>
                </div>
                <div class="card-body">
                  <!-- Primary Information -->
                  <p class="mb-2 fw-semibold">{{ row.desc }}</p>
                  
                  <!-- Time Information -->
                  <div class="row g-2 mb-3">
                    <div class="col-md-3">
                      <small class="text-muted">Date time:</small>
                      <div class="fw-medium">{{ formatDateTime(row.datetime) || 'Not specified' }}</div>
                    </div>
                    <div class="col-md-3">
                      <small class="text-muted">Distance:</small>
                      <div class="fw-medium">{{ row.distance || 'Not specified' }}</div>
                    </div>
                    <div class="col-md-3">
                      <small class="text-muted">fscale:</small>
                      <div class="fw-medium">{{ row.fscale || 'Not specified' }}</div>
                    </div>
                    <div class="col-md-3">
                      <small class="text-muted">Location:</small>
                      <div class="fw-medium">{{ row.latitude || '-' }}, {{ row.longitude || '-' }}</div>
                    </div>
                  </div>
                  
                </div>
              </div>
            </div>
          </div>
          <div v-else-if="gridView === 'queryInfo'">
            <h5>Query Information</h5>
            <div class="mt-3">
              <!-- Location Properties Card -->
              <div class="card">
                <div class="card-header bg-light">
                  <h6 class="mb-0"><i class="bi bi-geo-alt me-2"></i>Location Details</h6>
                </div>
                <div class="card-body">
                  <div class="row g-3">
                    <!-- Location Information -->
                    <div class="col-md-6">
                      <div class="mb-3">
                        <small class="text-muted d-block">Address</small>
                        <strong>{{ resultData.address || '-' }}</strong>
                      </div>
                      <div class="mb-3">
                        <small class="text-muted d-block">Resolved Address</small>
                        <strong>{{ resultData.resolvedAddress || '-' }}</strong>
                      </div>
                      <div v-if="resultData.name" class="mb-3">
                        <small class="text-muted d-block">Name</small>
                        <strong>{{ resultData.name }}</strong>
                      </div>
                    </div>

                    <!-- Geographic Information -->
                    <div class="col-md-6">
                      <div class="mb-3">
                        <small class="text-muted d-block">Coordinates</small>
                        <strong>{{ resultData.latitude?.toFixed(3) || '-' }}, {{ resultData.longitude?.toFixed(3) ||
                          '-'
                        }}</strong>
                      </div>
                      <div v-if="resultData.elevation !== null && resultData.elevation !== undefined" class="mb-3">
                        <small class="text-muted d-block">Elevation</small>
                        <strong>{{ resultData.elevation.toFixed(1) }} </strong>
                      </div>
                      <div class="mb-3">
                        <small class="text-muted d-block">Timezone</small>
                        <strong>{{ resultData.timezone || '-' }} (UTC{{ resultData.tzoffset >= 0 ? '+' : '' }}{{
                          resultData.tzoffset }})</strong>
                      </div>
                    </div>
                  </div>

                  <!-- Description if available -->
                  <div v-if="resultData.description" class="mt-3 pt-3 border-top">
                    <small class="text-muted d-block mb-1">Current Weather Summary</small>
                    <div class="text-dark">{{ resultData.description }}</div>
                  </div>

                  <!-- Query Cost -->
                   <!--
                  <div v-if="resultData.queryCost" class="mt-3 pt-3 border-top">
                    <small class="text-muted d-block mb-1">Query Cost</small>
                    <strong>{{ resultData.queryCost }} credits</strong>
                  </div>
                  -->
                </div>
              </div>
            </div>
            <h5>Weather Stations</h5>
            <StationInfoWidget :weather-data="resultData" :parent-data="true" :queryDefn="queryDefn"
              :config="{ unitgroup: queryDefn.unitGroup }" />
          </div>

          <div v-else-if="groupedMode">
            <div class="table-scroll-wrapper position-relative">
              <button class="scroll-arrow scroll-arrow-left" @click="scrollTable('left')" aria-label="Scroll left"
                v-if="canScrollLeft">
                <i class="bi bi-arrow-left-circle-fill"></i>
              </button>
              <button class="scroll-arrow scroll-arrow-right" @click="scrollTable('right')" aria-label="Scroll right"
                v-if="canScrollRight">
                <i class="bi bi-arrow-right-circle-fill"></i>
              </button>
              <div class="table-responsive" ref="tableScroll">
                <table class="table table-striped text-nowrap fs-xs">
                  <thead>
                    <!-- Top row: Group names (always show all groups, even if no element selected) -->
                    <tr>


                      <template v-for="(g, gid) in groupsEnriched" :key="gid">
                        <th class="align-middle bg-light border-bottom"
                          :colspan="Math.max(1, selectedIdsByGroup[gid]?.length || 0)">
                          <div class="d-flex flex-row align-items-center">
                            <button type="button" class="btn btn-link p-0" @click="openElementsPickerForGroup(gid)"
                              :aria-label="`Edit elements for ${g.label || humanizeFieldName(gid)}`">
                              {{ g.label || humanizeFieldName(gid) }}

                            </button>
                            <hr class="flex-grow-1 ms-2 me-1 group-hr" />
                          </div>
                        </th>
                      </template>
                    </tr>

                    <!-- Second row: element headers (show placeholder if none) -->
                    <tr>

                      <template v-for="(g, gid) in groupsEnriched" :key="gid + '-cols'">
                        <template v-if="(selectedIdsByGroup[gid] || []).length">
                          <th v-for="(eid, eidIndex) in selectedIdsByGroup[gid]" :key="gid + '-' + eid"
                            class="text-break text-wrap " :class="{
                              'group-border-left': eidIndex === 0,
                              'group-border-right': eidIndex === selectedIdsByGroup[gid].length - 1
                            }" style="min-width: 110px; max-width: 200px;">
                            <!-- element header with meta popover -->
                            <div class="d-flex align-items-start justify-content-between">
                              <span class="text-body flex-grow-1" tabindex="0" role="button" :title="metaTitle(eid)">
                                {{ labelOf(eid) }}
                              </span>
                              <VcTooltip :title="labelOf(eid)" :content="metaContent(eid)" placement="bottom"
                                trigger="hover">
                                <a href="#" class="ms-1 text-muted opacity-50">

                                  <i class="bi bi-info-circle"></i>
                                </a>
                              </VcTooltip>
                            </div>
                          </th>
                        </template>
                        <template v-else>
                          <!-- still show a placeholder column for empty groups -->
                          <th class="text-muted fst-italic group-border-left group-border-right">None selected</th>
                        </template>
                      </template>
                    </tr>
                  </thead>

                  <tbody>


                    <template v-for="(row, index) in gridData" :key="row._key">
                      <tr :class="{ 'blur-row': costSaverMode && blurAboveIndex && index >= blurAboveIndex }">
                        <template v-for="(gid, groupIndex) in Object.keys(groupsEnriched)" :key="gid">
                          <template v-if="selectedIdsByGroup[gid]?.length">
                            <td v-for="(eid, eidIndex) in selectedIdsByGroup[gid]"
                              :key="(row._key || index) + '-' + eid" class="text-end" :class="{
                                'group-border-left': eidIndex === 0,
                                'group-border-right': eidIndex === selectedIdsByGroup[gid].length - 1
                              }">
                              {{ formatValue(row, eid) }}
                            </td>
                          </template>
                          <template v-else>
                            <td :key="`placeholder-${gid}-${row._key || index}`"
                              class="text-muted fst-italic group-border-left group-border-right">-</td>
                          </template>
                        </template>
                      </tr>
                    </template>

                  </tbody>
                </table>


              </div>
            </div>
            <!-- Pagination -->
            <nav aria-label="Grid pagination">

              <button type="button" class="btn btn-sm text-primary px-1 py-0"
                @click="hideUnusedGroups = !hideUnusedGroups">
                <template v-if="!hideUnusedGroups">
                  <span><span class=""> Hide empty groups</span></span>
                </template>
                <template v-else>
                  <span><span class=""> Show empty groups</span></span>
                </template>
              </button>

              <ul v-if="totalPages > 1" class="pagination justify-content-center">
                <li class="page-item" :class="{ disabled: currentPage === 1 }">
                  <a class="page-link" href="#" @click.prevent="setPage(currentPage - 1)">Previous</a>
                </li>
                <li v-for="page in visiblePageNumbers" :key="page" class="page-item"
                  :class="{ active: page === currentPage }">
                  <a class="page-link" href="#" @click.prevent="setPage(page)">{{ page }}</a>
                </li>
                <li class="page-item" :class="{ disabled: currentPage === totalPages }">
                  <a class="page-link" href="#" @click.prevent="setPage(currentPage + 1)">Next</a>
                </li>
              </ul>
            </nav>
          </div>
          <!--
          <div v-else class="grid-container">
            <div class="table-responsive">
              <table class="table table-striped text-nowrap fs-xs">
                <thead class="sticky-top bg-white">
                  <tr>
                    <th v-for="(column, index) in gridColumns" :key="index">
                      {{ column.label }}
                      <span v-if="column.unit" class="text-muted small">({{ column.unit }})</span>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(row, rowIndex) in gridData" :key="rowIndex"
                    :class="{ 'blur-row': costSaverMode && blurAboveIndex && rowIndex >= blurAboveIndex }">
                    <td v-for="(column, colIndex) in gridColumns" :key="colIndex">
                      {{ formatValue(row, column.field) }}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          -->
        </div>




      </div>



    </template>



    <!--MODALS-->
    <template v-if="showMetadataInfo">
      <div class="modal-backdrop fade show" @click="showMetadataInfo = false"></div>
      <div class="modal fade show" style="display: block;" tabindex="-1" aria-labelledby="tutorialModalLabel"
        aria-modal="true" @keydown.esc="showMetadataInfo = false">
        <div class="modal-dialog modal-dialog-centered">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title" id="tutorialModalLabel">Dataset Information</h5>
              <button type="button" class="btn-close" @click="showMetadataInfo = false" aria-label="Close"></button>
            </div>
            <div class="modal-body">
              <div class="mb-3">
                <label for="name-input" class="form-label">Name</label>
                <input class="form-control" type="text" id="name-input" v-model="metadataCopy.name" placeholder="Name"
                  ref="nameInput" @keyup.enter="saveMetadataChanges">
              </div>
              <div v-if="metadataCopy.desc || showMetadataDesc" class="mb-3">
                <label for="desc-input" class="form-label">Description (optional)</label>
                <textarea class="form-control" id="desc-input" rows="2" v-model="metadataCopy.desc"
                  placeholder="Description" ref="descInput"></textarea>
              </div>
              <div v-else class="mb-3">
                <button type="button" class="btn btn-link btn-sm p-0" @click="modifyMetadataDesc()">
                  <i class="bi bi-plus"></i> Add description
                </button>
              </div>
              <div>Saved datasets can be loaded from <a href="#" class="text-primary text-decoration-underline"
                          @click="openMyDatasetsDialog()">My
                          Datasets</a>
              </div>

              <div class="d-flex mt-2 gap-2 d-row justify-content-end">
                <button type="button" class="btn btn-secondary" :disabled="showConfirmOverwrite"
                  @click="cancelMetadataChanges()">
                  Cancel
                </button>
                <button type="button" class="btn btn-primary" :disabled="showConfirmOverwrite"
                  @click="savePackageAndMetadata()">
                  Save Changes
                </button>

              </div>

              <div v-if="savePackageErrorMessage" class="alert alert-danger mt-3" role="alert">
                {{ savePackageErrorMessage }}
              </div>

              <div v-if="showConfirmOverwrite" class="alert alert-warning mt-3" role="alert">
                A package with the name "<strong>{{ currentName(packageDefn) }}</strong>" already
                exists. Do you want to
                overwrite it?
                <div class="mt-2">
                  <button type="button" class="btn btn-sm btn-primary me-2"
                    @click="confirmOverwrite">Yes, Overwrite</button>
                  <button type="button" class="btn btn-sm btn-secondary"
                    @click="cancelOverwrite">Cancel</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </template>

    <template v-if="showTutorialModal">
      <div class="modal-backdrop fade show" @click="hideTutorial"></div>

      <div class="modal fade show" style="display: block;" tabindex="-1" aria-labelledby="tutorialModalLabel"
        aria-modal="true" @keydown.esc="hideTutorial">

        <div class="modal-dialog modal-dialog-centered">
          <div v-if="tutorial" class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title" id="tutorialModalLabel">{{ tutorial.title }}</h5>
              <button type="button" class="btn-close" @click="hideTutorial" aria-label="Close"></button>
            </div>
            <div class="modal-body" v-html="tutorial.content"></div>
            <div class="modal-footer">
              <button type="button" class="btn btn-primary" @click="hideTutorial">Close</button>
            </div>
          </div>
        </div>
      </div>
    </template>




    <QueryOptionsEditor v-if="showTimelineQueryEditor" :show="showTimelineQueryEditor" :queryDefinition="queryDefn"
      @save="updateQueryDefn" @close="showTimelineQueryEditor = false" />

    <!-- Element Picker Modal -->
    <ElementPickerModal v-if="showElementPicker" v-model="elementsString" :show="showElementPicker"
      @update:show="showElementPicker = $event" :unit-group="queryDefn.unitGroup" :apiversion="apiversion"
      :defaultElements="defaultElements" :focusGroup="elementPickerFocusGroup" @close="showElementPicker = false"
      @save="onElementsSelected" />



    <FeedbackDialog 
      :show="showFeedbackDialog"
      title="Query Builder Feedback"
      question="Did the query builder work for you?"
      placeholder="What worked well? What could be improved?"
      help-text="Your feedback helps us improve the query builder experience."
      feature-name="QueryBuilder"
      @close="showFeedbackDialog = false"
      @submit="handleFeedbackSubmit"
    />

    <CommonModals />
  </div>

</template>

<script>
import { sanitizeText }  from '@/utils/sanitizeInput';
import DownloadDialog from './queryapp/DownloadDialog.vue';
import { isValidWeatherStatisticsDefn } from './weatherstatistics/weatherstatisticsutils.js';
import { QueryCostCalculator } from '@/visualcrossing-core/querycostcalculator';
import { VcClipboardUtils } from '@/visualcrossing-core/vcclipboardutils';
import { VcJobStatus } from '@/visualcrossing-core/vcjobstatus';
import { VcQueryLanguageGenerator } from "@/visualcrossing-core/vcquerylanguagegenerator";
import VcTooltip from './VcTooltip.vue';
import {defaultPackageName, invalidPackageMessage} from './queryapp/queryapputils.js';
import { usePackageSave } from './queryapp/usePackageSave.js';
import UnitGroupDropdown from './UnitGroupDropdown.vue';
import CommonModals from '@/components/CommonModals.vue'
import LocationsEditor from '@/components/LocationsEditor.vue'
import QueryOptionsEditor from './queryapp/QueryOptionsEditor.vue';
import BulkDefinitionsList from './BulkDefinitionsList.vue'

import WeatherChartDashboard from './queryapp/WeatherChartDashboard.vue';

import "/src/visualcrossing-core/vccommunicator_metadata";
import "/src/visualcrossing-core/vccommunicator_bulkdata";
import "/src/visualcrossing-core/vccommunicator_account";
import { VcDateUtils } from '/src/visualcrossing-core/vcdateutils';
import { VcListUtils } from '/src/visualcrossing-core/vclistutils';
import { VcLocationsStorage } from "/src/visualcrossing-core/vclocationsstorage";
import { VcConversion } from "/src/visualcrossing-core/vcconversion";
import '/src/website-core/VcUtils';
import { VcGlobal } from '/src/visualcrossing-core/vcglobal_conn';
import StationInfoWidget from '@/wxwidgets/station-info-widget.vue'
import DateRangeChooser from './DateRangeChooser.vue';
import SignUp from './SignUp.vue';
import { VcFindMyLocation } from '/src/visualcrossing-core/vcfindmylocation';

import WeatherStatisticsEditor from './WeatherStatisticsEditor.vue'
import "leaflet/dist/leaflet.css";
import L from "leaflet";
import { max } from 'd3';
import ElementPickerModal from './queryapp/ElementPickerModal.vue';
import { ELEMENT_META, resolveUnit } from '@/data/elementInfoMeta';
import { getAllGroupsEnriched } from '@/data/elementInfo';
import DownloadPreviewer from "./DownloadPreviewer.vue";
import FeedbackDialog from './FeedbackDialog.vue';
export default {
  name: 'queryApp',
  props: {

  },
  setup() {
    // Initialize the composable
    const { isSaving: packageSaving, saveError: packageSaveError, savePackage: savePackageCore, checkExistingPackage } = usePackageSave();
    
    return {
      packageSaving,
      packageSaveError,
      savePackageCore,
      checkExistingPackage
    };
  },
  data() {
    return {
      showFeedbackDialog: false,
      didYouKnowTip: null,
      lastDidYouKnowRefresh: 0,
      //showJSON: false,
      //showCSV: false,
      lastFullRetrievalQueryDefn: null,
      copyButtonText: 'Copy',
      //sourceLocations: [],
      groupedMode: true,
      showLocationDropdownMenu: false,
      showTutorialModal: false,
      showSignup: false,
      showTimelineQueryEditor: false,
      elementPickerFocusGroup: null,

      dataSections: [
        { id: 'days', label: 'Days', icon: 'bi bi-calendar3', description: 'Daily data', query: true },
        { id: 'hours', label: 'Hours', icon: 'bi bi-clock', description: 'Hourly data', query: true },
        { id: 'minutes', label: 'Minutes', icon: 'bi bi-stopwatch', description: 'Minute data', query: false },
        { id: 'current', label: 'Current', icon: 'bi bi-thermometer-half', description: 'Current conditions', query: true },
        { id: 'events', label: 'Events', icon: 'bi bi-exclamation-triangle', description: 'Weather events', query: true },
        { id: 'alerts', label: 'Alerts', icon: 'bi bi-bell', description: 'Weather alerts', query: true }
      ],
      packageDefn: {
        addressFields: [],
        latitudeColumnId: null,
        longitudeColumnId: null,
        nameColumnId: null,
        params: {
          "goal": "timeline",
          "startdate": null,
          "enddate": null,
          "unitGroup": "metric",
          "contentType": "json",
          "options": "",
          "include": "",
          "maxDistance": -1,
        },
        runTimes: [],
        enabled: true,
        runOnce: false,
        lastRunTime: 0,
        repeatInterval: 0,
        enableNotifications: false,
        notificationAddresses: [],
        type: 4,
        maxResultCount: 1,
        maxResultAge: 3,
        locations: [],
      },

      selectedLocationIndex: -1,

      //processedData: [],
      newLocation: null,
      manualLocationAdd: false,
      resultData: null,
      showDateChooser: false,
      errorMessage: null,
      isRefreshing: false,
      view: 'grid',
      costSaverMode: true,
      hideUnusedGroups: false,
      retrieveFullData: false,
      isContainerInited: false,
      sessionId: null,
      sessionState: null,
      gridView: "days",

      locationsHistory: null,
      tutorial: null,

      //exportComplete: false,
      tutorials: {
        welcome: {
          id: "welcome",
          title: "Welcome to Weather Query Builder!",
          content: "<p>Design, preview and view weather data for free.</p><p>You can then download the data as a CSV, Excel or JSON file. Alteratively switch to the API view to see the Weather API query.</p"
        },

        dashboard_intro: {
          id: "dashboard_intro",
          title: "Weather Chart Dashboard (Beta)",
          content: "<p>The Weather Chart Dashboard allows you to create interactive weather charts for your location and time period.</p><p>You can customize the chart appearance, add multiple locations, and share or embed the charts.</p>"
        },
      },

      showElementPicker: false,
      currentPage: 1,
      itemsPerPage: 25,
      blurAboveIndex: 5,
      apiQueryUrl: null,
      showAIAPIAssistant: false,
      scrollAmount: 400, // px to scroll per click
      tableScrollLeft: 0,
      tableScrollWidth: 0,
      tableScrollOffsetWidth: 0,
      showAPIDialog: false,
      showDownloadDialog: false,
      showMyDatasetsDialog: false,
      showLocationsDialog: false,
      locationsDraft: null,
      //showCostBreakdown: false,
      //costBreakdownMaximized: false,
      //costBreakdownOriginalParent: null,
      //costBreakdownOriginalNextSibling: null,
      showWeatherStatsDialog: false,
      usageInfo: null,
      //subscriptionMode: false,
      // apiQueryDraft: null,
      apiPackageDraft: null,
      statsPackageDraft: null,
      //downloadQueryDraft: null,
      //downloadPackageDraft: null,
      //startingStep: 0,
      //downloadStep: 0,
      //downloadSteps: [],
      downloadDialogMode: 'download', // or 'schedule'
      metadata: this.metadataProp || {
        id: null,
        name: null,
        desc: null
      },
      metadataCopy: null,
      showMetadataInfo: false,
      showMetadataDesc: false,
      //taskInstance: null,
      /*
      pollingState: {
        isPolling: false,
        pollingRetries: 0,
        hasExceedRetries: false,
        isRefreshingResults: false,
        pollingTimer: null,
      },*/
      previewRawData: {
        errorMessage: null,
        isRefreshing: false,
        resultData: null
      },
      //isSaving: false,
      //savePackageErrorMessage: null,
      //showConfirmOverwrite: false,
      //packageName: '',
      newPackageName: '',
      //confirmationMessage: null,
      overwriteResolve: null,
            showConfirmOverwrite: false,
      confirmationMessage: null,
      overwriteResolve: null,
      existingPackageToOverwrite: null,
    }
  },
  methods: {
    showFeedback() {
        this.showFeedbackDialog = true;
      
    },
    handleFeedbackSubmit(feedbackData) {
      // Handle the feedback submission
      console.log('Feedback received:', feedbackData);
      
      // You can add any additional processing here
      // For example, show a success message
      if (window.VcCommonModals?.showAlert) {
        window.VcCommonModals.showAlert(
          'Thank You!',
          'Your feedback has been submitted successfully.',
          'Close'
        );
      }
      
      // Close the dialog (it also closes itself)
      this.showFeedbackDialog = false;
    },
    toggleSectionQuery(sectionId) {
      const section = this.getDataSection(sectionId);
      if (!section) return;
      
      // Toggle the query property
      section.query = !section.query;
      this.refreshData();
      // Update the include parameter based on which sections have query=true
      //this.updateIncludeFromSections();
      
      // Log analytics
      if (window["gtag"]) {
        gtag('event', `section_query_${sectionId}_${section.query ? 'on' : 'off'}`, { method: 'Vc' });
      }
    },
    /*
    updateIncludeFromSections() {
      // Build the include string from sections with query=true
      const includeSections = this.dataSections
        .filter(s => s.query === true)
        .map(s => s.id);
      
      // Update the package definition
      this.packageDefn.params.include = includeSections.join(',');
      
      // This will trigger the watcher and refresh data
      console.log('Updated include sections:', this.packageDefn.params.include);
    },
    */
    // Update the existing getDataSection method if needed
    getDataSection(sectionId) {
      return this.dataSections.find(s => s.id === sectionId);
    },
    /*
    updateStatsDefinition(statsDefnInfo, localPackage) {

      if (localPackage && localPackage.params) {
        localPackage.params.statsdefinition = statsDefnInfo.statsDefn;

        // Update goal if provided
        if (statsDefnInfo.goal) {
          localPackage.params.goal = statsDefnInfo.goal;
        }


      }
    },
    */
    hasValidWeatherStatsDefn(localPackage) {
      const localQueryDefn = localPackage?.params;
      return localQueryDefn && isValidWeatherStatisticsDefn(localQueryDefn);
    },
    formatDateTime(epochSecs) {
      return VcDateUtils.formatDateTime2(epochSecs, null, {
        year: 'numeric',
        month: 'long',
        day: 'numeric',
        hour: 'numeric',
        minute: 'numeric',
        hour12: false
      })
    },
    handleDashboardPackageUpdated(newPackage) {
      if (!newPackage || !newPackage.params) return;
      this.queryDefn.dashboarddefinition = newPackage.params.dashboarddefinition;
      //console.log("Dashboard package updated", newPackage);
    },
    formatCompactNumber(num) {
      if (num === null || num === undefined) return '0';
      if (typeof num === 'string') return num; // For "No limit"

      if (num >= 1000000) {
        return (num / 1000000).toFixed(1) + 'M';
      } else if (num >= 1000) {
        return (num / 1000).toFixed(1) + 'K';
      }
      return num.toLocaleString();
    },
    refreshUsageInfo() {
      var me = this;
      const vcCommunicator = window.vcCommunicator;
      if (!vcCommunicator) {
        return;
      }

      vcCommunicator.usagesummary(true, false, false)
        .then(function (result) {

          me.usageInfo = result;

        }).catch((error) => {
          console.log("Error loading usage info")
        });
    },



    isElementVisibleInGroup(id) {
      const meta = ELEMENT_META[id];
      if (this.groupedMode && meta?.sections && !meta.sections.includes(this.gridView)) {
        return false;
      }
      return this.selectedSet.has(id);
    },
    deepClone(obj) {
      try {
        return (window.structuredClone) ? structuredClone(obj) : JSON.parse(JSON.stringify(obj));
      } catch (e) {
        return JSON.parse(JSON.stringify(obj));
      }
    },
    recomputeApiQueryUrlFrom(qd) {
      const apiKey = this.sessionState?.apiKey || "YOUR_API_KEY";
      const defn = this.deepClone(qd);
      if (this.selectedLocation) {
        defn.location = this.selectedLocation.location;
        defn.name = this.selectedLocation.name;
      }
      this.apiQueryUrl = VcQueryLanguageGenerator.generateCode("http", defn, apiKey);
    },
    // PATCH: section helpers that work against a provided package object
    selectedSectionsFrom(qd) {
      const include = qd?.include;
      if (!include) return ['days', 'hours', 'current', 'alerts'];
      return include.split(',').map(s => s.trim()).filter(Boolean);
    },
    isSectionSelectedIn(qd, sectionId) {
      return this.selectedSectionsFrom(qd).includes(sectionId);
    },
    isSingleSectionOnlyFor(qd) {
      const t = qd?.contentType;
      return t === 'csv' || t === 'xlsx';
    },
    toggleSectionIn(qd, sectionId, recompute = false) {
      if (!qd) return;
      let sections = [...this.selectedSectionsFrom(qd)];
      const idx = sections.indexOf(sectionId);
      const isSingle = this.isSingleSectionOnlyFor(qd);

      if (isSingle) sections = [sectionId];
      else (idx > -1) ? sections.splice(idx, 1) : sections.push(sectionId);

      qd.include = sections.join(',');

      if (recompute && this.showAPIDialog && qd) {
        this.recomputeApiQueryUrlFrom(qd);
      }
      if (window["gtag"]) gtag('event', 'section_toggle_' + sectionId, { method: 'Vc' });
    },


    getExistingPackageByName(existingJobPackages, name) {

      if (!existingJobPackages) return null;
      name = (name && name.toLowerCase());
      return existingJobPackages.reduce(function (a, d) {
        return a || (d && d.name && d.name.toLowerCase() === name && d);
      }, null);
    },

    confirmOverwriteInternal(existingPackage, packageName) {
      return new Promise((resolve) => {
        // Store the resolve function so we can call it from the UI handlers
        this.overwriteResolve = resolve;
        this.showConfirmOverwrite = existingPackage;
        this.confirmOverwritePackageName = packageName;
      });
    },
    confirmOverwritePackage(localPackage) {
      this.metadata = this.showConfirmOverwrite;
      // User confirmed
      this.showConfirmOverwrite = false;

      // Resolve the promise with true (user confirmed)
      if (this.overwriteResolve) {
        this.overwriteResolve(true);
        this.overwriteResolve = null;
      }
    },
    // Add a cancel overwrite method
    cancelOverwritePackage() {
      // User cancelled
      this.showConfirmOverwrite = false;

      // Resolve the promise with false (user cancelled)
      if (this.overwriteResolve) {
        this.overwriteResolve(false);
        this.overwriteResolve = null;
      }
    },

 
/*
    async saveScheduledPackage(localPackage) {
      //localPackage.runOnce = false;
      if (!localPackage.runTimes?.length) {
        return;
      }
      const result = await this.savePackage(localPackage);
      if (result.success) {
        if (localPackage.runOnce) {
          this.startPollForCompletion();
        } else {
          this.confirmationMessage = 'Package saved successfully.';
          setTimeout(() => {
            this.confirmationMessage = null;
            this.closeDownloadDialog();
          }, 2000);
        }


      }
    },*/
    async savePackage(localPackage, ignoreNameCheck = false) {
      // Use the composable's savePackage
      const result = await this.savePackageCore(
        localPackage,
        this.metadata,
        this.sessionState,
        {
          skipDuplicateCheck: ignoreNameCheck,
          onConfirmOverwrite: async (existingPackage, packageName) => {
            // Show confirmation dialog
            return new Promise((resolve) => {
              this.showConfirmOverwrite = true;
              this.existingPackageToOverwrite = existingPackage;
              this.confirmationMessage = `A package named "${packageName}" already exists. Do you want to overwrite it?`;
              this.overwriteResolve = resolve;
            });
          }
        }
      );
      
      if (result.success) {
        // Update metadata
        this.metadata = result.metadata;
        
       
        // Show success message
        //if (window.VcCommonModals) {
        //  window.VcCommonModals.showInfo("Success", "Package saved successfully!");
        //}
      } else if (result.code === 'SAVE_FAILED') {
        // Error is already set in the composable
        if (window.VcCommonModals) {
          window.VcCommonModals.showError("Save Failed", result.error);
        }
      }
      
      return result;
    },
    
    // Handle confirmation dialog
    confirmOverwrite() {
      this.showConfirmOverwrite = false;
      if (this.overwriteResolve) {
        this.metadata = this.existingPackageToOverwrite; // Update metadata
        this.overwriteResolve(true);
        this.overwriteResolve = null;
      }
    },
    
    cancelOverwrite() {
      this.showConfirmOverwrite = false;
      if (this.overwriteResolve) {
        this.overwriteResolve(false);
        this.overwriteResolve = null;
      }
    },
    // Replace the savePackage method around line 1963
    /*
    async savePackage(localPackage, ignoreNameCheck = false) {
      const vcCommunicator = window.vcCommunicator;

      // Return a promise that handles all the confirmation flow internally
      return new Promise(async (resolve, reject) => {

        // Validation
        if (!this.isPackageValid(localPackage) || !vcCommunicator) {
          const result = {
            success: false,
            error: 'Invalid package or no communicator',
            code: 'INVALID_PACKAGE'
          };
          resolve(result);
          return;
        }

        const packageName = this.currentName(localPackage);
        let existingPackage = null;
        // Check for duplicates unless explicitly ignoring

        try {
          let existingJobPackages = await vcCommunicator.searchMetadata(null, "JobPackage");
          existingJobPackages = existingJobPackages?.result || [];

          if (!this.metadata.id) {
            existingPackage = this.getExistingPackageByName(existingJobPackages, packageName);
            if (existingPackage) {
              // Handle overwrite confirmation internally
              const userConfirmed = await this.confirmOverwriteInternal(existingPackage, packageName);

              if (!userConfirmed) {
                // User cancelled the overwrite
                resolve({
                  success: false,
                  error: 'User cancelled overwrite',
                  code: 'USER_CANCELLED',
                  existingPackage
                });
                return;
              }

              // User confirmed, update metadata and continue
              this.metadata = existingPackage;
            }
          }
        } catch (error) {
          resolve({
            success: false,
            error: 'Failed to check existing packages',
            code: 'CHECK_FAILED',
            details: error
          });
          return;
        }


        // Proceed with save
        this.isSaving = true;

        try {
          localPackage.accountUserId = this.sessionState && this.sessionState.userMdId;

          const result = await vcCommunicator.saveBulkSourceDefn(
            this.metadata.id,
            packageName,
            this.metadata.desc,
            localPackage
          );

          if (result && result.metadata) {
            this.metadata = result.metadata;
          }



          this.isSaving = false;
          // Return success with metadata
          resolve({
            success: true,
            metadata: result.metadata,
            result: result,
            wasOverwritten: !!existingPackage
          });

        } catch (error) {
          console.error('Failed to save package:', error);
          this.savePackageErrorMessage = 'Failed to save the job package.';
          this.isSaving = false;

          resolve({
            success: false,
            error: error.message || 'Failed to save package',
            code: 'SAVE_FAILED',
            details: error
          });
        }
      });
    },

    */


    isPackageValid(localPackage) {
      if (!localPackage) return false;
      return !invalidPackageMessage(localPackage) && this.hasSession;
    },
    /*
    invalidPackageMessage(localPackage) {
      if (localPackage.locations.length === 0) return "No valid locations selected.";
      return null;
    },*/
    // Update the currentName method around line 1170
    currentName(metadata, localPackage) {
      

      return (metadata && metadata.name) || defaultPackageName(localPackage);
    },

    
    // Update the modifyMetadata method around line 1240
    saveAs(localPackage, createNew) {
      var me = this;

      if (!me.hasSession) {
        me.errorMessage = "You must be logged in to use this feature.";
        return;
      }
      if (createNew) {
        me.metadata = {
          id: null,
          name: null,
          desc: null
        };
        me.newPackageName = ''; // Clear when starting new
      } else {
        me.metadata.id = null;
      }
      //me.savePackageErrorMessage = null;
      me.packageName = ''; // Clear packageName when editing
      me.metadataCopy = JSON.parse(JSON.stringify(me.metadata));
      if (!me.metadataCopy.name) me.metadataCopy.name = defaultPackageName(localPackage);

      me.showMetadataDesc = false;
      me.showMetadataInfo = true;

      // Focus the input after Vue updates the DOM
      me.$nextTick(() => {
        if (me.$refs.nameInput) {
          me.$refs.nameInput.focus();
          me.$refs.nameInput.select();
        }
      });
    },
    saveMetadataChanges() {
      var me = this;

      me.metadataCopy.name = sanitizeText(me.metadataCopy.name, 100);
      me.metadataCopy.desc = sanitizeText(me.metadataCopy.desc, 250);

      me.metadata.name = me.metadataCopy.name;
      me.metadata.desc = me.metadataCopy.desc;
      me.metadataCopy = null;
      me.showMetadataDesc = false;
      me.showMetadataInfo = false;

    },

    async savePackageAndMetadata() {
      var me = this;

      me.metadataCopy.name = sanitizeText(me.metadataCopy.name, 100);
      me.metadataCopy.desc = sanitizeText(me.metadataCopy.desc, 250);

      me.metadata.name = me.metadataCopy.name;
      me.metadata.desc = me.metadataCopy.desc;
      const result = await this.savePackage(this.packageDefn);

      if (result.success) {
        this.showMetadataInfo = false;
        this.metadataCopy = null;
        this.showMetadataDesc = false;

        if (result.wasOverwritten) {

        } else {

        }

        me.metadataCopy = null;
        me.showMetadataDesc = false;
        me.showMetadataInfo = false;
      }
    },
    modifyMetadataDesc() {
      var me = this;
      me.showMetadataDesc = true;
      me.$nextTick(() => {
        if (me.$refs.descInput) {
          me.$refs.descInput.focus();
          me.$refs.descInput.select();
        }
      });

    },
    cancelMetadataChanges() {
      var me = this;
      me.metadataCopy = null;
      me.showMetadataDesc = false;
      me.showMetadataInfo = false;
    },

    getDayCount() {
      // Calculate number of days in the query
      if (!this.queryDefn.startdate) return 15; // Default forecast

      const start = new Date(this.queryDefn.startdate);
      const end = this.queryDefn.enddate ? new Date(this.queryDefn.enddate) : new Date();

      const diffTime = Math.abs(end - start);
      const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

      return diffDays + 1; // Include both start and end dates
    },
    // Add this to your methods:
    highlightCode() {
      this.$nextTick(() => {
        if (window.Prism) {
          // Target only the specific pre elements instead of all
          const preElements = this.$el.querySelectorAll('pre code[class*="language-"]');
          preElements.forEach(element => {
            Prism.highlightElement(element);
          });
        }
      });
    },
    handleTableScroll() {
      const el = this.$refs.tableScroll;
      if (el) {
        this.tableScrollLeft = el.scrollLeft;
        this.tableScrollWidth = el.scrollWidth;
        this.tableScrollOffsetWidth = el.offsetWidth;
      }
    },
    scrollTable(direction) {
      const el = this.$refs.tableScroll;
      if (!el) return;
      const amount = direction === 'left' ? -this.scrollAmount : this.scrollAmount;
      el.scrollBy({ left: amount, behavior: 'smooth' });
    },
    getValidGridView() {
      // Determine which grid views are available based on include
      const includes = this.selectedSections;

      // If current gridView is still valid, keep it
      if (this.isGridViewValid(this.gridView, includes)) {
        return this.gridView;
      }

      // Otherwise, find the first valid view in order of preference
      const viewPriority = ['days', 'hours', 'minutes', 'current', 'events', 'alerts'];

      for (const view of viewPriority) {
        if (this.isGridViewValid(view, includes)) {
          return view;
        }
      }

      // Default fallback
      return 'days';
    },

    isGridViewValid(view, includes) {
      // Special handling for views that don't require include
      if (view === 'queryInfo') return true;

      // If no includes specified, days is always available
      if (!includes || includes.length === 0) {
        return view === 'days';
      }

      // Check if the view matches the includes
      switch (view) {
        case 'days':
          return includes.includes('days') || includes.length === 0;
        case 'hours':
          return includes.includes('hours');
        case 'minutes':
          return includes.includes('minutes');
        case 'current':
          return includes.includes('current');
        case 'events':
          return includes.includes('events');
        case 'alerts':
          return includes.includes('alerts');
        default:
          return false;
      }
    },
    isSectionSelected(sectionId) {
      const sections = this.selectedSections;
      return sections.includes(sectionId);
    },

    toggleSection(sectionId) {
      let sections = [...this.selectedSections];

      if (this.isSingleSectionOnly) {
        // For CSV/XLS, only allow one section
        if (this.isSectionSelected(sectionId)) {
          // Deselect if clicking the same section - set to empty
          sections = [];
        } else {
          // Replace with new selection
          sections = [sectionId];
        }
      } else {
        // For JSON/JSONFlat, allow multiple sections
        const index = sections.indexOf(sectionId);
        if (index > -1) {
          sections.splice(index, 1);
        } else {
          sections.push(sectionId);
        }
      }

      // Update the package definition
      this.packageDefn.params.include = sections.join(',');

      // The watcher will automatically handle gridView changes

      // Log analytics
      if (window["gtag"]) {
        gtag('event', 'section_toggle_' + sectionId, { method: 'Vc' });
      }
    },



    setContentType(queryDefn, type, recompute = false) {
      const previousType = queryDefn.contentType;
      if (previousType === type) return;

      queryDefn.contentType = type;


      const wasSingle = previousType === 'csv' || previousType === 'xlsx';
      const isSingle = type === 'csv' || type === 'xlsx';

      if (!wasSingle && isSingle) {
        // Get sections from the provided package (dialog) when available, otherwise main
        const sections = this.selectedSectionsFrom(queryDefn);
        let chosen = sections[0] || 'days';
        // enforce single in both places
        queryDefn.include = chosen;
      }

      if (recompute && this.showAPIDialog) {
        this.recomputeApiQueryUrlFrom(queryDefn);
      }
      if (window["gtag"]) gtag('event', 'content_type_' + type, { method: 'Vc' });
    },

    async copyApiUrl() {
      try {
        await navigator.clipboard.writeText(this.apiQueryUrl);
        this.copyButtonText = 'Copied!';
        this.copyButtonIcon = 'bi-check2';

        // Reset after 2 seconds
        setTimeout(() => {
          this.copyButtonText = 'Copy';
          this.copyButtonIcon = 'bi-clipboard';
        }, 2000);
      } catch (err) {
        console.error('Failed to copy:', err);
        this.copyButtonText = 'Failed';
        this.copyButtonIcon = 'bi-x';

        setTimeout(() => {
          this.copyButtonText = 'Copy';
          this.copyButtonIcon = 'bi-clipboard';
        }, 2000);
      }
    },
    labelOf(id) {
      // Prefer enriched label if we have it
      for (const g of Object.values(this.groupsEnriched)) {
        const f = g.elements.find(e => e.id === id);
        if (f) return f.label + (f.unit ? ' (' + f.unit + ')' : '') || this.humanizeFieldName(id);
      }
      return this.humanizeFieldName(id);
    },
    metaTitle(id) {
      const e = this.findElement(id);
      if (!e) return this.labelOf(id);
      return e.label;
    },
    metaContent(id) {
      const e = this.findElement(id);
      if (!e) return '';
      const bits = [];
      if (e.description) bits.push(e.description);
      if (e.unit) bits.push(`Unit: ${e.unit}`);
      //if (Number.isFinite(e.precision)) bits.push(`Precision: ${e.precision} dp`);
      if (e.aggregation) bits.push(`Aggregation: ${e.aggregation}`);
      return bits.join('\n');
    },
    findElement(id) {
      for (const g of Object.values(this.groupsEnriched)) {
        const f = g.elements.find(e => e.id === id);
        if (f) return f;
      }
      return null;
    },

    formatValue(row, eid) {
      const meta = ELEMENT_META[eid] || {};
      let value;

      // Always source these fields from the top-level resultData
      const TOP_LEVEL_FIELDS = new Set([
        'name', 'address', 'resolvedAddress',
        'latitude', 'longitude',
        'elevation', 'timezone', 'tzoffset'
      ]);

      if (eid === 'name') {
        value = this.resultData?.name
             ?? this.resultData?.resolvedAddress
             ?? this.resultData?.address;
      } else if (TOP_LEVEL_FIELDS.has(eid)) {
        value = this.resultData?.[eid];
      } else {
        value = row?.[eid];
      }

      return this.formatCellValue(value, { ...meta, field: eid });
    },
    openElementsPickerForGroup(group) {
      this.elementPickerFocusGroup = group;
      this.showElementPicker = true;
    },
    closeElementPicker() {
      this.showElementPicker = false;
      this.elementPickerFocusGroup = null;
    },
    handleDropdownClick(event) {
      // Close dropdown when clicking on dropdown items
      const isDropdownItem = event.target.closest('.dropdown-item');
      if (isDropdownItem) {
        this.showLocationDropdownMenu = false;
      }
    },
    // Handle clicks outside dropdown
    handleClickOutside(event) {
      if (this.$refs.locationDropdown && !this.$refs.locationDropdown.contains(event.target)) {
        this.showLocationDropdownMenu = false;
      }
    },

    // Handle ESC key globally
    handleKeyDown(event) {
      if (event.key === 'Escape') {
        if (this.showTutorialModal) {
          this.hideTutorial();
        } else if (this.showLocationDropdownMenu) {
          this.showLocationDropdownMenu = false;
        }
      }
    },

    findMyLocation() {
      var me = this;
      var fml = VcFindMyLocation.findMyLocation(true);

      fml.then(location => {
        me.addLocation(location);
      })
        .catch(error => {
          console.log("Could not find location..." + error)
        });
    },
    setDateRange(startPeriod, endPeriod) {

      let me = this;

      me.queryDefn.startdate = startPeriod;
      me.queryDefn.enddate = endPeriod;
      //console.log("Set date range:"+defn.startdate +"=> "+defn.enddate);

    },

    setView(view) {
      if (window["gtag"]) {
        gtag('event', 'data_view_' + view, { method: 'Vc' });
      }

      if (view === this.view) {
        //this.view = 'grid';
      } else {
        this.showTutorial("dashboard_intro", true);
        this.view = view;
      }
    },
    openStatsDialog() {
      this.statsPackageDraft = this.deepClone(this.packageDefn);
      this.showWeatherStatsDialog = true;
    },
    closeStatsDialog() {
      this.showWeatherStatsDialog = false;
      this.statsPackageDraft = null;
    },
    openAPIDialog() {
      this.apiPackageDraft = this.deepClone(this.packageDefn);
      this.recomputeApiQueryUrlFrom(this.apiQueryDraft);
      this.showAPIDialog = true;
    },
    openDownloadDialog(type = 'download') {
      this.downloadDialogMode = type;
      this.showDownloadDialog = true;
    },
    closeDownloadDialog() {
      this.showDownloadDialog = false;
      this.downloadDialogMode = 'download';
    },
    handlePackageSaved(metadata, localPackage) {
      this.setMetadata(metadata, localPackage);
    },
    showTutorial(id, dismissable) {
      var me = this;
      if (dismissable && VcLocationsStorage.getValue("tutorial_" + id)) return;

      me.tutorial = me.tutorials[id];
      if (!me.tutorial) return;

      // Use Vue state instead of Bootstrap
      me.showTutorialModal = true;
    },

    hideTutorial() {
      var me = this;
      // Close modal using Vue state
      me.showTutorialModal = false;
      // Save dismissal state
      if (me.tutorial) {
        VcLocationsStorage.setValue("tutorial_" + me.tutorial.id, 1);
      }
      // Clear tutorial data
      me.tutorial = null;
    },

    closeAllDialogs() {
      this.closeAPIDialog();
      this.closeDownloadDialog();
      this.closeMyDatasetsDialog();
      this.closeLocationsDialog();
      this.closeStatsDialog();
      this.closeElementPicker();
      this.closeTimelineQueryEditor();
      this.closeMetadataInfo();
    },
    closeMetadataInfo() {
      this.showMetadataInfo = false;
    },
    // Add dialog close handlers
    closeTimelineQueryEditor() {
      this.showTimelineQueryEditor = false;
    },
    closeAPIDialog() {
      this.showAPIDialog = false;
      this.apiPackageDraft = null;
    },
    showSignIn() {
      this.closeAllDialogs();
      window.dialogManager?.showSignIn();
    },
    showSignUpDialog() {
      this.closeAllDialogs();
      this.showSignup = true;
    },


    openMyDatasetsDialog() {
      this.closeAllDialogs();
      this.showMyDatasetsDialog = true;
    },
    closeMyDatasetsDialog() {
      this.showMyDatasetsDialog = false;
    },
    openLocationsDialog() {
      this.closeAllDialogs();
      this.locationsDraft = JSON.parse(JSON.stringify(this.locations));
      this.showLocationsDialog = true;


    },
    handleLocationsChanged(locations) {
      this.locationsDraft = locations;
    },
    applyLocationChanges() {
      if (this.locationsDraft) {
        this.packageDefn.locations = JSON.parse(JSON.stringify(this.locationsDraft));
      }
      this.closeLocationsDialog();
    },
    closeLocationsDialog() {
      this.showLocationsDialog = false;
      this.locationsDraft = null;
    },


    setMetadata(metadata, packageDefn) {
      console.log("setmetadata...")
      var me = this;
      me.taskInstance = metadata.instance || null;
      me.closeMyDatasetsDialog();
      me.metadata = metadata;
      if (packageDefn) {
        me.packageDefn = packageDefn;
        me.selectedLocationIndex = 0;
        //me.setDateSelectionType(null);
      }

      if (packageDefn && packageDefn.params && packageDefn.params.dashboarddefinition) {
        me.view = 'dashboard';
      }
    },
    setGridView(value) {
      console.log("GridView:" + value)
      this.gridView = value;
    },


    changeCostSaver(value, confirm) {
      console.log("Change cost saver", value);
      let me = this;
      if (!value && !confirm) {
        window.VcCommonModals.showConfirm("Confirm full dataset mode",
          "Enabling full dataset mode will show all rows of your dataset within the browser. Your account will be debited for this data usage and charges may apply. You may return to preview mode at any time. Do you want to continue?")
          .then(function (id) {
            me.changeCostSaver(value, true);
          }).catch((error) => {

          });

        return;
      }

      if (window["gtag"]) {
        gtag('event', 'costsaver_' + (value ? "on" : "off"), { method: 'Vc' });
      }

      me.costSaverMode = value;

    },


    showLocationEdit() {
      var me = this;
      me.manualLocationAdd = true;
      if (me.locations[me.selectedLocationIndex]) {
        me.newLocation = me.locations[me.selectedLocationIndex].location;
      }
    },

    handleSelectLocation(location) {
      var me = this;
      var index = me.locations.indexOf(location);
      me.selectedLocationIndex = index !== -1 ? index : 0;

    },
    /*
    handleLocationsChanged(locations) {
      //this.locations=locations; //no need as locations are bound
      var me = this;
      //me.resultData = null;
      if (!locations.length) {
        me.selectedLocationIndex = -1;
        return;
      } else if (me.selectedLocationIndex < 0) {
        me.selectedLocationIndex = 0;
      } else if (me.selectedLocationIndex >= locations.length) {
        me.selectedLocationIndex = locations.length - 1;
      }


    },
    */
    getDataSection(sectionId) {
      const section = this.dataSections.find(s => s.id === sectionId);
      return section;
    },
    getLocationText(location, maxLength) {
      if (!location) return "-";
      if (maxLength <= 0) return location.name || location.location;
      return VcUtils.truncate(location.name || location.location, maxLength / 2, maxLength / 2);
    },
    changeSelectedLocation(index) {
      this.selectedLocationIndex = index;
      this.showLocationDropdownMenu = false; // Close dropdown after selection

    },
    hasLocationsHistory() {
      return this.locationsHistory && this.locationsHistory.length;
    },
    refreshLocationsHistory() {
      //console.log("refreshLocationsHistory")
      this.locationsHistory = VcLocationsStorage.getLocations();
    },
    cancelDataRefresh() {

      this.isRefreshing = false;
      // Optionally cancel any ongoing requests here
    },
    refreshData(confirm) {
      var me = this;
      console.log("refreshData");

      if (me.showAPIDialog || me.showDownloadDialog) {
        // Do not refresh data while dialogs are open
        return;
      }

      me.refreshLocationsHistory();

      me.retrieveFullData = me.hasSession && (confirm || !me.costSaverMode);
      me.errorMessage = null;
      if (!me.selectedLocation || !me.selectedLocation.location) return;
      VcLocationsStorage.addLocation(me.selectedLocation);



      if (!me.queryDefn.startdate && me.queryDefn.enddate) {
        me.errorMessage = "Please select a valid date range";
        return;
      }


      const apiKey = me.sessionState?.apikey || "YOUR_API_KEY";
      var apiQueryDefn = JSON.parse(JSON.stringify(me.queryDefn));
      if (me.selectedLocation) {
        apiQueryDefn.location = me.selectedLocation.location;
        apiQueryDefn.name = me.selectedLocation.name;
      }
      me.apiQueryUrl = VcQueryLanguageGenerator.generateCode("http", apiQueryDefn, apiKey);

      var retrievalQueryDefn = JSON.parse(JSON.stringify(me.queryDefn));
      if (!me.retrieveFullData) {
        retrievalQueryDefn.options = VcListUtils.setValueInList(retrievalQueryDefn.options, "preview", true, false);
        //retrievalQueryDefn.key=VcGlobal.QUERY_BUILDER_KEY;
        if (window["gtag"]) {
          gtag('event', 'data_preview', { method: 'Vc' });
        }

      } else {
        if (window["gtag"]) {
          gtag('event', 'data_full', { method: 'Vc' });
        }
      }
      if (retrievalQueryDefn.elements) {
        retrievalQueryDefn.elements = VcListUtils.setValueInList(retrievalQueryDefn.elements, "add:datetimeEpoch", true, false);
      }
      
      retrievalQueryDefn.include = this.dataSections.reduce((acc, section) => {
        if (section.query) {
          if (acc.length) acc += ",";
          acc += section.id;
        }
        return acc;
        
      }, "");

      //retrievalQueryDefn.include=null;
      let fullRetrievalQueryDefn = JSON.parse(JSON.stringify(retrievalQueryDefn));
      fullRetrievalQueryDefn.location = me.selectedLocation.location;
      fullRetrievalQueryDefn.name = me.selectedLocation.name;
      fullRetrievalQueryDefn = JSON.stringify(fullRetrievalQueryDefn);
      if (me.lastFullRetrievalQueryDefn && me.lastFullRetrievalQueryDefn == fullRetrievalQueryDefn) {
        console.log("Skipping full data retrieval - already retrieved for this query");
        return;
      }

      const detailedQueryCost = QueryCostCalculator.calculate(retrievalQueryDefn);
      const estimateQueryCost = detailedQueryCost?.estimatedCost || 0;
      console.log(`Estimated query cost: ${estimateQueryCost}`);

      if (!confirm && estimateQueryCost > 10000 && !me.costSaverMode) {
        window.VcCommonModals.showConfirm("High data volume detected",
          `The requested data retrieval is estimated to use  ${estimateQueryCost} records.  To retrieve the full dataset, please confirm you wish to proceed. Do you want to retrieve the full dataset?`,
          `Yes, retrieve full data`, 
        `No, view preview only`)
          .then(function (id) {

            if (window["gtag"]) {
              gtag('event', 'confirm_high_data_volume', { method: 'Vc' });
            }

            me.refreshData(true);
            
          }).catch((error) => {
            if (window["gtag"]) {
              gtag('event', 'cancel_high_data_volume', { method: 'Vc' });
            }
            me.costSaverMode = true;
            me.refreshData(false);
          });

        return;
      }

      let loadingTimeout = setTimeout(() => {
          me.isRefreshing = true;
      }, 500); // 300ms delay before showing loading

      me.lastFullRetrievalQueryDefn = fullRetrievalQueryDefn;
      vcCommunicator.retrieveTimelineData(retrievalQueryDefn, me.selectedLocation.location, me.selectedLocation.name, "json", true, false)
        .then(response => {
          clearTimeout(loadingTimeout); // Cancel loading indicator if still pending
          me.resultData = response;
          me.isRefreshing = false;

        }).catch((error) => {
          clearTimeout(loadingTimeout); // Cancel loading indicator if still pending
          if (!me.retrieveFullData) {
            me.errorMessage = "Unable to retrieve preview data. If this issue persists, please change to viewing the full dataset. Error: " + error;;
          } else {
            me.errorMessage = error;
          }

          me.isRefreshing = false;
        });
    },
    addLocation(location, name) {
      var me = this;

      if (me.newLocation) {
        me.newLocation = sanitizeText(me.newLocation, 250);
      }
      if (location && typeof location === 'string') {
        location = sanitizeText(location, 250);
      }
      
      if (name && typeof name === 'string') {
        name = sanitizeText(name, 150);
      }

      location = location || me.newLocation;
      var newLocation = null;
      if (location && location.location) {
        newLocation = location;

      } else if (me.locations[me.selectedLocationIndex]) {
        me.locations[me.selectedLocationIndex].location = location;


      } else {
        newLocation = {
          location: location,
          name: name
        }

      }
      me.manualLocationAdd = false;
      const isDuplicate = newLocation && me.locations.some(loc => loc.location === newLocation.location && loc.name === newLocation.name);
      if (newLocation && !isDuplicate) {
        me.locations.push(newLocation);
        me.selectedLocationIndex = me.locations.length - 1;

      }

      //me.refreshData();
    },
    updateQueryDefn(updatedQueryDefn) {
      var me = this;

      // Update the package definition params with the new query definition
      me.packageDefn.params = updatedQueryDefn;

      // Close the timeline query editor
      me.showTimelineQueryEditor = false;


      // Optional: Log for debugging
      console.log('Updated query definition:', updatedQueryDefn);
    },

    openQueryEditor() {
      var me = this;

      me.showTimelineQueryEditor = true;
    },

    openDataSectionsEditor() {
      this.openQueryEditor('datasections');
    },

    openElementsEditor() {
      this.openQueryEditor('elements');
    },


    // Grid-specific methods
    paginatedData(data) {
      const start = (this.currentPage - 1) * this.itemsPerPage;
      const end = start + this.itemsPerPage;
      return data.slice(start, end);
    },

    setPage(page) {
      if (page >= 1 && page <= this.totalPages) {
        this.currentPage = page;
      }
    },





    formatCellValue(value, column) {
      if (value === null || value === undefined) return '-';

      // Handle different formats
      switch (column.format) {
        case 'datetime':
          return this.formatDateTime(value);
        case 'date':
          return this.formatDate(value);
        case 'array':
          return Array.isArray(value) ? value.join(', ') : value;
        case 'boolean':
          return value ? 'Yes' : 'No';
        case 'percent':
          return `${value}%`;
        case 'temperature':
          return `${value.toFixed(column.precision || 1)}°`;
        default:
          if (typeof value === 'number' && column.precision !== undefined) {
            return value.toFixed(column.precision);
          }
          return value;
      }
    },

    formatDate(dateStr) {
      if (!dateStr) return '-';
      const date = new Date(dateStr);
      return date.toLocaleDateString();
    },

    formatDateTime(dateStr) {
      if (!dateStr) return '-';
      const date = new Date(dateStr);
      return date.toLocaleString();
    },



    humanizeFieldName(fieldName) {
      return fieldName
        .replace(/([A-Z])/g, ' $1')
        .replace(/^./, str => str.toUpperCase())
        .trim();
    },


    onElementsSelected(selectedIds) {
      // dialog-aware elements target
      if (this.showAPIDialog && this.apiQueryDraft) {
        this.apiQueryDraft.elements = selectedIds;
        this.recomputeApiQueryUrlFrom(this.apiQueryDraft);
      } else if (this.showDownloadDialog && this.downloadQueryDraft) {
        this.downloadQueryDraft.elements = selectedIds;
        // no API recompute needed in download dialog
      } else if (this.queryDefn) {
        this.queryDefn.elements = selectedIds;
        this.refreshData();
      }
      this.showElementPicker = false;
    },

    // Override the existing setGridView to handle pagination reset
    setGridView(value) {
      console.log("GridView:" + value);
      this.gridView = value;
      this.currentPage = 1; // Reset to first page when changing view
    },
    
    

  },

  computed: {
    packageRefreshKey() {
    // Only include properties that should trigger a data refresh
      const relevantData = {
        startdate: this.packageDefn.params?.startdate,
        enddate: this.packageDefn.params?.enddate,
        unitGroup: this.packageDefn.params?.unitGroup,
        include: this.packageDefn.params?.include,
        elements: this.packageDefn.params?.elements,
        options: this.packageDefn.params?.options,
        contentType: this.packageDefn.params?.contentType,
        locations: this.packageDefn.locations?.map(l => l.location).join(',')
      };
      
      return JSON.stringify(relevantData);
    },
    isCurrentGridViewInQuery() {
   
      const section = this.getDataSection(this.gridView);
      return section ? section.query === true : false;
    },
    formattedApiQueryUrl() {
      if (!this.apiQueryUrl) return '';

      try {
        const url = new URL(this.apiQueryUrl);
        const params = Array.from(url.searchParams.entries());

        // Format the URL with parameters on separate lines
        let formatted = `${url.origin}${url.pathname}`;

        if (params.length > 0) {
          formatted += '?\n';
          params.forEach(([key, value], index) => {
            if (index > 0) {
              formatted += `  &${key}=${value}`;
            } else {
              formatted += `  ${key}=${value}`;
            }
            if (index < params.length - 1) {
              formatted += '\n';
            }
          });
        }

        return formatted;
      } catch (e) {
        // Fallback for invalid URLs
        return this.apiQueryUrl;
      }
    },
    isSaving() {
      return this.packageSaving;
    },
    savePackageErrorMessage() {
      return this.packageSaveError;
    },
    validLocationChanges() {
      return this.locationsDraft && this.locationsDraft.length > 0 && JSON.stringify(this.locationsDraft) !== JSON.stringify(this.locations);
    },
    hasSchedule() {
      return this.packageDefn && this.packageDefn.runTimes && this.packageDefn.runTimes.length > 0;
    },
    hasWeatherStats() {
      return this.hasValidWeatherStatsDefn(this.packageDefn);
    },
    /*
    contentType() {
      var me = this;
      return me.queryDefn.contentType;
    },*/
    detailedQueryCost() {
      let queryDefn = this.queryDefn;
      if (this.showAPIDialog && this.apiPackageDraft) {
        queryDefn = this.apiQueryDraft;
      }

      const result = QueryCostCalculator.calculate(queryDefn);
      return result;
    },
    estimateLocationCost() {
      return this.detailedQueryCost?.estimatedCost || 0;
    },
    textResultsUri() {
      var me = this;

      return vcCommunicator.constructBulkWeatherDataRequest(me.metadata, true, false);
    },
    zipResultsUri() {
      var me = this;
      return vcCommunicator.constructBulkWeatherDataRequest(me.metadata, true, true);
    },
    hasSavedDefn() {
      return this.metadata && this.metadata.id;
    },
        // Location-related computed properties
    locationCount() {
      return (this.locations && this.locations.length) || 0;
    },
    /*
    processingStatusText() {
      if (!this.taskInstance) return "Submitting...";
      if (this.taskInstance.status === 1) return "Queued";
      if (this.taskInstance.status === 2) {
        if (this.taskInstance.completed > 1 && this.taskInstance.total > 1) {
          return `Running ${this.taskInstance.completed} of ${this.taskInstance.total}`;
        } else {
          return "Running";
        }
      }
      return null;
    },
    notStarted() {
      return !this.pollingState.isRefreshingResults;
      //(!this.taskInstance || !this.taskInstance.status) &&  
    },
    isProcessing() {
      return this.pollingState.isRefreshingResults ||
        (this.taskInstance && (this.taskInstance.status === 1 || this.taskInstance.status === 2));
    },
    hasResult() {
      return this.taskInstance && this.taskInstance.status === 3;
    },
    hasResultError() {
      return this.taskInstance && this.taskInstance.status === 4;
    },
    hasExpired() {
      return this.taskInstance && this.taskInstance.status === 5;
    },
    downloadStepErrorMessage() {
      //if (!this.hasSession) return "You must be logged in to download data.";
      return null;
    },



    estimateLocationCost() {

      // Estimate the cost per location based on the query
      return this.detailedQueryCost?.estimatedCost || 0;

    },

    estimateQueryCost() {
      // Total estimated cost for all locations
      return this.estimateLocationCost * this.locationCount;
    },

    queryMeteredCostDetails() {
      if (!this.estimateQueryCost) return "-";

      const recordText = this.estimateQueryCost === 1 ? 'record' : 'records';

      if (this.isMetered) {
        const price = (this.estimateQueryCost * 0.0001);
        if (price < 0.01) {
          return `${this.estimateQueryCost} ${recordText} (< $0.01)`;
        }
        return `${this.estimateQueryCost} ${recordText} ($${(this.estimateQueryCost * 0.0001).toFixed(2)})`;
      } else {
        return `${this.estimateQueryCost} ${recordText}`;
      }
    },

    currentDailyCost() {
      var me = this;
      if (!me.usageInfo || !me.usageInfo.currentPeriodUsage) return 0;
      return me.usageInfo.currentPeriodUsage.cost;
    },
    currentMonthlyCost() {
      var me = this;
      if (!me.usageInfo || !me.usageInfo.currentPeriodUsage) return 0;
      return me.usageInfo.currentPeriodUsage.periodQueryCost || 0;
    },
    dailyCostLimit() {
      return this.formatNumber(this.subscriptionParams?.maxDailyCost) || "No limit";
    },
    monthlyCostLimit() {
      return this.formatNumber(this.subscriptionParams?.maxMonthlyCost) || "No limit";
    },
    dailyUsagePercent() {
      const limit = this.subscriptionParams?.maxDailyCost;
      if (!limit || limit === 0) return 0;
      const percent = (this.currentDailyCost / limit) * 100;
      return Math.min(100, Math.max(0, percent));
    },

    monthlyUsagePercent() {
      const limit = this.subscriptionParams?.maxMonthlyCost;
      if (!limit || limit === 0) return 0;
      const percent = (this.currentMonthlyCost / limit) * 100;
      return Math.min(100, Math.max(0, percent));
    },

    dailyUsageClass() {
      const percent = this.dailyUsagePercent;
      if (percent >= 90) return 'bg-danger';
      if (percent >= 75) return 'bg-warning';
      return 'bg-success';
    },

    monthlyUsageClass() {
      const percent = this.monthlyUsagePercent;
      if (percent >= 90) return 'bg-danger';
      if (percent >= 75) return 'bg-warning';
      return 'bg-success';
    },
    remainingFreeDailyCost() {
      // Get remaining free daily allowance
      const freeDailyCost = this.subscriptionParams?.freeDailyCost || 0;
      const used = this.currentDailyCost;
      return Math.max(0, freeDailyCost - used);
    },
    bulkAllowSubscription() {
      return this.subscriptionParams?.bulkAllowSubscriptions === 1 && !this.exceedsLimit;
    },
    hasDailyLimit() {
      return this.subscriptionParams?.maxDailyCost && this.subscriptionParams.maxDailyCost > 0;
    },
    hasMonthlyLimit() {
      return this.subscriptionParams?.maxMonthlyCost && this.subscriptionParams.maxMonthlyCost > 0;
    },
    exceedsLimit() {
      // Check if query exceeds account limits
      if (!this.isMetered) return false;

      const estimatedCost = this.estimateQueryCost;
      const maxDailyCost = this.subscriptionParams?.maxDailyCost || 0;
      const maxMonthlyCost = this.subscriptionParams?.maxMonthlyCost || 0;
      const currentDaily = this.currentDailyCost || 0;
      const currentMonthly = this.currentMonthlyCost || 0;

      return (maxDailyCost > 0 && currentDaily + estimatedCost > maxDailyCost) ||
        (maxMonthlyCost > 0 && maxMonthlyCost + estimatedCost > maxMonthlyCost);
    },

    exceedsLimitMsg() {
      if (!this.exceedsLimit) return "";

      const estimatedCost = this.estimateQueryCost;
      const maxDailyCost = this.subscriptionParams?.maxDailyCost || 0;
      const maxMonthlyCost = this.subscriptionParams?.maxMonthlyCost || 0;
      const currentDaily = this.currentDailyCost;
      const currentMonthly = this.sessionState?.usage?.monthly?.cost || 0;

      if (maxDailyCost > 0 && currentDaily + estimatedCost > maxDailyCost) {
        return `This query will exceed your daily limit of ${maxDailyCost} records. You have used ${currentDaily} records today.`;
      }

      if (maxMonthlyCost > 0 && currentMonthly + estimatedCost > maxMonthlyCost) {
        return `This query will exceed your monthly limit of ${maxMonthlyCost} records. You have used ${currentMonthly} records this month.`;
      }

      return "";
    },

    isExtendedDataset() {
      // Check if this is an extended dataset (very large)
      //return true;
      const totalRecords = this.estimateQueryCost;
      return totalRecords > 1000000; // Adjust threshold as needed
    },

    largeDataset() {
      // Check if this is a large dataset
      const totalRecords = this.estimateQueryCost;
      return totalRecords > 100000 && !this.isExtendedDataset;
    },

    formattedApiQueryUrl() {
      if (!this.apiQueryUrl) return '';

      try {
        const url = new URL(this.apiQueryUrl);
        const params = Array.from(url.searchParams.entries());

        // Format the URL with parameters on separate lines
        let formatted = `${url.origin}${url.pathname}`;

        if (params.length > 0) {
          formatted += '?\n';
          params.forEach(([key, value], index) => {
            if (index > 0) {
              formatted += `  &${key}=${value}`;
            } else {
              formatted += `  ${key}=${value}`;
            }
            if (index < params.length - 1) {
              formatted += '\n';
            }
          });
        }

        return formatted;
      } catch (e) {
        // Fallback for invalid URLs
        return this.apiQueryUrl;
      }
    },
    */
    canScrollLeft() {
      return this.tableScrollLeft > 0;
    },
    canScrollRight() {
      return this.tableScrollLeft + this.tableScrollOffsetWidth < this.tableScrollWidth - 1;
    },
    isSingleSectionOnly() {
      const contentType = this.packageDefn.params.contentType;
      return contentType === 'csv' || contentType === 'xlsx';
    },

    selectedSections() {
      const include = this.packageDefn.params.include;
      if (!include) return [];
      return include.split(',').map(s => s.trim()).filter(Boolean);
    },

    hasSelectedSection() {
      return this.selectedSections.length > 0;
    },

    selectedSectionsDisplay() {
      return this.selectedSections.join(', ');
    },
    apiversion() {
      return this.subscriptionParams?.apiVersion || '10';
    },
    defaultElements() {
      if (this.apiversion === "20") {
        return ["datetime", "name", "tempmax", "tempmin", "temp", "feelslikemax", "feelslikemin", "feelslike", "humidity", "precip", "precipprob", "snow", "snowdepth", "windgust", "windspeed", "winddir", "cloudcover", "visibility", "aqius", "uvindex2", "conditions", "description", "icon"];
      } else {
        return ["datetime", "datetimeEpoch", "name", "tempmax", "tempmin", "temp", "feelslikemax", "feelslikemin", "feelslike", "dew", "humidity", "precip", "precipprob", "precipcover", "preciptype", "snow", "snowdepth", "windgust", "windspeed", "winddir", "pressure", "cloudcover", "visibility", "solarradiation", "solarenergy", "uvindex", "severerisk", "sunrise", "sunset", "moonphase", "conditions", "description", "icon", "stations", "offset", "source", "sunriseEpoch", "sunsetEpoch"];
      }
    },
    groupsEnriched() {
      const metaMap = ELEMENT_META;
      const transform = (el) => {
        const m = metaMap[el.id] || {};
        return {
          ...el,
          unit: el.unit ?? resolveUnit(m.unit, this.queryDefn.unitGroup),
          aggregation: el.aggregation ?? m.aggregation ?? 'none'
        };
      };

      let groups = getAllGroupsEnriched(this.queryDefn.unitGroup);
      if (!this.hideUnusedGroups) return groups;
      return Object.fromEntries(
        Object.entries(groups).filter(([gid, g]) => {
          return g.elements
            .map(e => e.id)
            .filter(this.isElementVisibleInGroup).length > 0;
        }
        )
      );

    },
    // Group -> element ids (only those selected)
    selectedIdsByGroup() {
      const map = {};
      for (const [gid, g] of Object.entries(this.groupsEnriched)) {
        map[gid] = g.elements
          .map(e => e.id)
          .filter(this.isElementVisibleInGroup);
      }
      return map;
    },

    selectedSet() {
      const elementsStr = this.queryDefn?.elements || '';
      const selected = new Set();
      const base = new Set(this.defaultElements);
      const tokens = elementsStr.split(',').map(s => s.trim()).filter(Boolean);
      const isDelta = tokens.some(t => /^add:|^remove:/i.test(t));

      if (!tokens.length && base.size) {
        // empty = default
        base.forEach(id => selected.add(id));
        return selected;
      }

      if (isDelta) {
        base.forEach(id => selected.add(id));
        for (const t of tokens) {
          const m = t.match(/^(add|remove):(.+)$/i);
          if (!m) continue;
          const op = m[1].toLowerCase();
          const id = m[2].trim();
          if (op === 'add') selected.add(id);
          else if (op === 'remove') selected.delete(id);
        }
      } else {
        for (const id of tokens) selected.add(id);
      }
      return selected;
    },

    // Grouped flattened order for rendering cells in grouped mode
    orderedElementIds() {
      const out = [];
      for (const gid of Object.keys(this.groupsEnriched)) {
        const list = this.selectedIdsByGroup[gid] || [];
        if (list.length) out.push(...list);
        else out.push(...["-"]); // keep order; columns represented via placeholder in header
      }
      return out;
    },




    previewLocations() {
      var me = this;
      if (!me.locations || !me.locations.length) return [];
      return me.locations.slice(0, 5);
    },
    hasMoreLocations() {
      var me = this;
      return me.locations && me.locations.length > 5;
    },
    resolvedDateRange() {
      var data = this.resultData;
      if (!data || !data.days) return "";
      if (data.days.length === 1) return data.days[0].datetime;

      return data.days[0].datetime + " > " + data.days[data.days.length - 1].datetime;
    },

    showChartAsHours() {
      var me = this;
      return me.resultData && me.resultData.days && me.resultData.days.length < 4 && me.hasHours;
    },
    hasHours() {
      //return this.queryDefn && (!this.queryDefn.include || (this.queryDefn.include && VcListUtils.hasValueInList(this.queryDefn.include, 'hours')));
      return this.dataSections.some(section => section.id === 'hours' && section.query === true);
    },
    hasDays() {
      return this.dataSections.some(section => section.id === 'days' && section.query === true);
    },
    hasMinutes() {
      return this.dataSections.some(section => section.id === 'minutes' && section.query === true);
    },
    hasCurrent() {
      return this.dataSections.some(section => section.id === 'current' && section.query === true);
    },
    hasAlerts() {
      return this.dataSections.some(section => section.id === 'alerts' && section.query === true);
    },
    hasEvents() {
      return this.dataSections.some(section => section.id === 'events' && section.query === true);
    },
    queryCost() {
      return this.resultData && this.resultData.queryCost;
    },
    queryCostDetails() {
      var me = this;
      if (!me.resultData || !me.resultData.queryCost) return "-";
      if (me.isMetered) {
        return `${this.resultData.queryCost} ($${(this.resultData.queryCost * 0.0001).toFixed(4)})`;
      } else {
        return `${this.resultData.queryCost}`;
      }
    },
    hasElements() {
      return this.queryDefn && this.queryDefn.elements && this.queryDefn.elements.length;
    },


    taskName() {
      return this.currentName(this.metadata, this.queryDefn) || "New Weather dataset";
    },
    accountUserId() {
      return this.sessionState && this.sessionState.userMdId;
    },
    subscriptionParams() {
      return this.sessionState && this.sessionState.subscriptionParams;
    },
    usageType() {
      return this.subscriptionParams && this.subscriptionParams.usageType;
    },
    hasCreateBulk() {
      return this.subscriptionParams && this.subscriptionParams.createBulk;
    },
    isMetered() {
      return this.usageType === "metered"
    },
    allowStatistics() {
      return this.subscriptionParams && this.subscriptionParams.allowStatistics;
    },


    // Grid-specific computed properties
    gridData() {
      if (!this.resultData) return null;

      switch (this.gridView) {
        case 'hours':
          if (this.hasHours) {
            const rows = [];
            this.resultData.days?.forEach(day => {
              
              day.hours?.forEach((hour, i) => {
                if (i % this.itemsPerPage === 0)  {
                  rows.push({
                    datetime: day.datetime,
                  });
                }
                rows.push({
                  ...hour,
                  //datetime: day.datetime + ' ' + hour.datetime,
                  // Inherit day-level data if needed
                  //sunrise: day.sunrise,
                  //sunset: day.sunset
                });
              });
            });
            return this.paginatedData(rows);
          }
          return null;

        case 'minutes':
          // Implement minutes data if available
          if (this.hasMinutes) {
            const rows = [];
            this.resultData.days?.forEach(day => {
             /// rows.push({
              //  datetime: day.datetime,
              //});
              day.hours?.forEach((hour, i)  => {
                if (!hour.minutes || !hour.minutes.length) return;

                if (i % this.itemsPerPage === 0)  {
                  rows.push({
                    datetime: day.datetime,
                  });
                }
                hour.minutes?.forEach((minute, j) => {

                  rows.push({
                    ...minute,
                    // datetime: day.datetime + ' ' + hour.datetime,
                  });
                });

              });
            });
            return this.paginatedData(rows);
          }
          return null;

        case 'current':
          // Current conditions as a single row
          if (this.resultData.currentConditions) {
            return [this.resultData.currentConditions];
          }
          return null;

        case 'events':
          const rows = [];
            this.resultData.days?.forEach(day => {
              
              day.events?.forEach((event, i) => {

                rows.push({
                  ...event,
                  //datetime: day.datetime + ' ' + hour.datetime,
                  // Inherit day-level data if needed
                  //sunrise: day.sunrise,
                  //sunset: day.sunset
                });
              });
            });
            return this.paginatedData(rows);


        case 'alerts':
          // Weather alerts
          return this.resultData.alerts || []
          //return this.paginatedData(this.resultData.alerts || []);

        case 'days':
        default:
          return this.paginatedData(this.resultData.days || []);
      }
    },



    // Helper method
    tempUnit() {
      const unitGroup = this.queryDefn?.unitGroup || 'metric';
      return unitGroup === 'metric' || unitGroup === 'uk' ? '°C' : '°F';
    },

    totalPages() {
      if (!this.resultData) return 0;

      let totalItems = 0;
      switch (this.gridView) {
        case 'hours':
          totalItems = this.resultData.days?.reduce((sum, day) => sum + (day.hours?.length || 0), 0) || 0;
          break;
        case 'minutes':
          totalItems = this.resultData.days?.reduce((sum, day) => sum + day.hours?.reduce((hourSum, hour) => hourSum + (hour.minutes?.length || 0), 0) || 0, 0) || 0;
          break;
        case 'current':
          totalItems = 1;
          break;
        case 'events':
          totalItems = this.resultData.events?.length || 0;
          break;
        case 'alerts':
          totalItems = this.resultData.alerts?.length || 0;
          break;
        case 'days':
        default:
          totalItems = this.resultData.days?.length || 0;
      }

      return Math.ceil(totalItems / this.itemsPerPage);
    },

    visiblePageNumbers() {
      const pages = [];
      const maxVisible = 5;
      let start = Math.max(1, this.currentPage - Math.floor(maxVisible / 2));
      let end = Math.min(this.totalPages, start + maxVisible - 1);

      if (end - start < maxVisible - 1) {
        start = Math.max(1, end - maxVisible + 1);
      }

      for (let i = start; i <= end; i++) {
        pages.push(i);
      }

      return pages;
    },

    elementsString: {
      get() {
        return this.queryDefn?.elements || '';
      },
      set(value) {
        if (this.queryDefn) {
          this.queryDefn.elements = value;
        }
      }
    },

    showLocationAdd() {
      return this.manualLocationAdd;
    },
    hasNoLocations() {
      return !this.locations || !this.locations.length;
    },
    hasMultiLocations() {
      return this.locationCount > 1;
    },
    hasSession() {
      return this.sessionId ? true : false;
    },
    showLocationDropdown() {
      return this.locations && this.locations.length > 0 && !this.manualLocationAdd;
    },
    queryDefn() {
      return this.packageDefn.params || {};
    },
    apiQueryDraft() {
      return this.apiPackageDraft?.params || {};
    },
    downloadQueryDraft() {
      return this.downloadPackageDraft?.params || {};;
    },
    locations() {
      return (this.packageDefn.locations) || null;
    },


    selectedLocationText() {
      return this.getLocationText(this.selectedLocation, 40);
    },
    selectedLocationTextLong() {
      return this.getLocationText(this.selectedLocation, 58);
    },
    selectedLocation() {
      return (this.locations && this.locations[this.selectedLocationIndex]) || null;
    },
    validLocation() {
      return this.selectedLocation;
    },
    apiRequest() {
      var me = this;
      return me.selectedLocation && me.queryDefn && me.selectedLocation.location &&
        vcCommunicator.createTimelineRequest(me.queryDefn, me.selectedLocation.location, me.selectedLocation.name, true)
    },
    isAdmin() {
      let me = this;
      return me.sessionState && me.sessionState.contextProperties && me.sessionState.contextProperties.isAdmin === "true";
    }
  },
  watch: {
    groupedMode(newVal) {
      this.$nextTick(() => {
        const el = this.$refs.tableScroll;
        if (el) {
          el.addEventListener('scroll', this.handleTableScroll);
          this.handleTableScroll();
        }
      });
    },
    hideUnusedGroups(newVal) {
      this.$nextTick(() => {
        const el = this.$refs.tableScroll;
        if (el) {
          el.addEventListener('scroll', this.handleTableScroll);
          this.handleTableScroll();
        }
      });
    },
    gridData() {
      this.$nextTick(() => {
        const el = this.$refs.tableScroll;
        if (el) {
          el.addEventListener('scroll', this.handleTableScroll);
          this.handleTableScroll();
        }
      });
    },
    showAPIDialog(newVal) {
      if (newVal) {
        this.$nextTick(() => {
          this.highlightCode();
        });
      }
    },
    apiQueryUrl() {
      // Re-highlight when URL changes
      this.$nextTick(() => {
        this.highlightCode();
      });
    },
    formattedApiQueryUrl(newVal) {
      if (newVal && this.showAPIDialog) {
        this.$nextTick(() => {
          this.highlightCode();
        });
      }
    },

    view(newView) {
      if (newView === 'api') {
        this.highlightCode();
      }
    },
    apiQueryDraft: {
      deep: true,
      handler(nv) {
        if (this.showAPIDialog && nv) this.recomputeApiQueryUrlFrom(nv);
      }
    },

    packageRefreshKey(newVal, oldVal) {
      if (newVal !== oldVal && oldVal !== undefined) {
        console.log('Package data changed, refreshing...');
        
        // Debounce the refresh
        clearTimeout(this.refreshTimeout);
        this.refreshTimeout = setTimeout(() => {
          this.refreshData();
        }, 300);
      }
    },
    // Watch for changes to packageDefn (deep watch to catch nested changes)
    /*
    packageDefn: {
      handler(newVal, oldVal) {
        if (JSON.stringify(newVal) !== JSON.stringify(oldVal)) {
          // Only refresh if there are actual changes
          console.log('packageDefn changed, refreshing data...');
          this.refreshData();
        } else {
          console.log('packageDefn change detected but no actual changes.');
        }
      },
      deep: true, // Watch for nested property changes
      immediate: false // Don't run on initial mount
    },
    */
    'queryDefn.include': {
      handler(newInclude, oldInclude) {
        // Check if current gridView is still valid for the new include
        const validGridView = this.getValidGridView();

        if (validGridView !== this.gridView) {
          console.log(`Include changed, switching gridView from ${this.gridView} to ${validGridView}`);
          //this.gridView = validGridView;
        }
      },
      immediate: true // Run on component mount
    },
    selectedLocation() {
      if (this.showAPIDialog && this.apiQueryDraft)
        this.recomputeApiQueryUrlFrom(this.apiQueryDraft);
    },
    // Watch for changes to selectedLocationIndex
    selectedLocationIndex: {
      handler(newIndex, oldIndex) {
        console.log(`selectedLocationIndex changed from ${oldIndex} to ${newIndex}, refreshing data...`);
        this.sourceLocations = this.locations; // Update sourceLocations when selection changes
        if (newIndex >= 0 && this.locations && this.locations[newIndex]) {
          this.refreshData();
        }
      },
      immediate: false // Don't run on initial mount
    },

    // Optional: Also watch the locations array if you want to refresh when locations are added/removed
    locations: {
      handler(newLocations, oldLocations) {
        console.log('locations array changed, checking if refresh needed...');
        // Only refresh if we have a valid selected location
        if (this.selectedLocationIndex >= 0 && newLocations && newLocations[this.selectedLocationIndex]) {
          this.refreshData();
        }
      },
      deep: true, // Watch for array changes and nested object changes
      immediate: false
    },
    costSaverMode(newValue, oldValue) {
      console.log("Cost saver mode changed to: " + newValue);

      this.refreshData();

    },
    resultData() {
      this.currentPage = 1;
    },

    gridView() {
      this.currentPage = 1;
    }
  },
  mounted() {
    const el = this.$refs.tableScroll;
    if (el) {
      el.addEventListener('scroll', () => this.$forceUpdate());
    }
    document.addEventListener('click', this.handleClickOutside);
    document.addEventListener('keydown', this.handleKeyDown);

    var me = this;
    const vcCommunicator = window.vcCommunicator;
    if (!vcCommunicator) {
      console.log("No vcCommunicator");
      return;
    }
    me.sessionId = vcCommunicator.sessionId;
    me.sessionState = vcCommunicator.sessionState;
    me.isContainerInited = vcCommunicator.isInited || me.sessionId;
    vcCommunicator.addHandler('createsession', function (sessionId, sessionState) {
      me.sessionId = sessionId;
      me.sessionState = sessionState;
      me.isContainerInited = true;
      me.showSignup = false;
      console.log(`mounted.createsession ${me.sessionId}, ${me.isContainerInited}, ${me.hasSession}`);
    });



    vcCommunicator.addHandler('terminatesession', function () {
      me.sessionId = null;
      me.sessionState = null;
      me.metadata = {
        id: null,
        name: null,
        desc: null
      };
      me.view = 'grid';
      me.costSaverMode = true;
      me.retrieveFullData = false;
      me.gridView = "days";
    });


    me.refreshLocationsHistory();

    var lastLocation = me.hasLocationsHistory() && me.locationsHistory[0];
    var savedUnitGroup = VcLocationsStorage.getUnitGroup();
    var launchLocation = null;
    var startdate = null;
    var enddate = null;

    if (window.vcconfig) {
      if (window.vcconfig.location === "<?php echo $location ?>") window.vcconfig.location = "Herndon,VA";
      if (window.vcconfig.unitGroup === "<?php echo $unitGroup ?>") window.vcconfig.unitGroup = "metric";
      if (window.vcconfig.startdate === "<?php echo $startDate ?>") window.vcconfig.startdate = "2018-01-01";
      if (window.vcconfig.enddate === "<?php echo $endDate ?>") window.vcconfig.enddate = "2018-02-01";


      if (!window.vcconfig.isDefault || !lastLocation) {
        if (window.vcconfig.location) {
          launchLocation = {
            location: window.vcconfig.location,
            name: null
          }

        }
        if (window.vcconfig.unitGroup) {
          me.unitGroup = window.vcconfig.unitGroup || savedUnitGroup
          VcLocationsStorage.setUnitGroup(me.unitGroup);
        }

        if (window.vcconfig.startdate) {
          startdate = window.vcconfig.startdate;
        }

        if (window.vcconfig.enddate) {
          enddate = window.vcconfig.enddate;
        }
      }
    }

    launchLocation = launchLocation || lastLocation;
    if (launchLocation) {
      me.locations.push(launchLocation);
      me.selectedLocationIndex = me.locations.length - 1;
      VcLocationsStorage.addLocation(launchLocation);
      me.refreshLocationsHistory();
    }

    var queryDefn = JSON.parse(JSON.stringify(me.queryDefn));
    queryDefn.unitGroup = me.unitGroup || savedUnitGroup || "us";
    queryDefn.startdate = startdate;
    queryDefn.enddate = enddate;
    //me.queryDefn=queryDefn;
    me.packageDefn.params = queryDefn;
    // me.refreshData();

    var requestedView = null;
    requestedView = VcUtils.qs["v"];
    if (requestedView === "api") {
      me.view = requestedView
    }


    me.showTutorial("welcome", true);
    this.$nextTick(() => {
      if (window.Prism) {
        window.Prism.highlightAll();
      }
    });
  },
  beforeUnmount() {
    // Clean up event listeners
    
    if (this.refreshTimeout) {
      clearTimeout(this.refreshTimeout);
    }

    document.removeEventListener('click', this.handleClickOutside);
    document.removeEventListener('keydown', this.handleKeyDown);
  },
  components: {
    FeedbackDialog,
    DownloadDialog,
    StationInfoWidget,
    VcTooltip,
    UnitGroupDropdown,
    LocationsEditor,

    QueryOptionsEditor,

    DownloadPreviewer,

    WeatherChartDashboard,

    BulkDefinitionsList,
    CommonModals,

    DateRangeChooser,
    SignUp,
    WeatherStatisticsEditor,
    ElementPickerModal

  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
/* Add to your scoped styles */
.cursor-pointer {
  cursor: pointer;
}

.card.cursor-pointer {
  transition: all 0.2s ease-in-out;
  user-select: none;
}

.card.cursor-pointer:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

.card.cursor-pointer:active {
  transform: translateY(0);
}

.card.cursor-pointer.opacity-50 {
  pointer-events: none;
}

:deep(.minheight50) {
  min-height: 50%;
}

:deep(.widget) {
  max-width: initial;
}

/* Add minimal CSS for dropdown functionality */
:deep(.dropdown-menu.show) {
  display: block;
}

/* Ensure proper z-index for dropdown */
.dropdown {
  position: relative;
}

.dropdown-menu {
  position: absolute;
  z-index: 1050;
}

/* Grid-specific styles */
.grid-container {
  overflow: auto;
  height: calc(100vh - 300px);
  /* Adjust based on your layout */
}

.table th {
  position: sticky;
  top: 0;
  background-color: white;
  z-index: 10;
}

:deep(.blur-row) {
  filter: blur(3px);
  opacity: 0.5;
}

:deep(.table-responsive) {
  max-height: calc(100vh - 350px);
  overflow-y: auto;
}

:deep(.grid-container) {
  overflow: auto;
  height: calc(100vh - 300px);
  /* Adjust based on your layout */
}

:deep(.group-border-left) {
  border-left: 1px solid #aaaaaa !important;
  /* or any color you prefer */
}

:deep(.group-border-right) {
  border-right: 1px solid #aaaaaa !important;
}

:deep(.group-hr) {
  border: none;
  border-bottom: 1px solid #00628b !important;
  height: 6px;
  margin: 0px;
  opacity: 1
}

.table-scroll-wrapper {
  position: relative;
}

.scroll-arrow {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  z-index: 20;
  background: rgba(255, 255, 255, 0.1);
  border-radius: 25px;
  border: none;
  font-size: 2.5rem;
  color: rgb(0, 98, 139);
  cursor: pointer;
  padding: 10px;
  transition: background 0.2s;
}

.scroll-arrow-left {
  left: 15px;
}

.scroll-arrow-right {
  right: 15px;
}

.scroll-arrow:hover {
  color: rgba(0, 98, 139, 0.8);
  background: rgba(255, 255, 255, 0.6);
}
</style>
